(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/@ionic/core/dist/esm lazy recursive ^\\.\\/.*\\.entry\\.js$ include: \\.entry\\.js$ exclude: \\.system\\.entry\\.js$":
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/@ionic/core/dist/esm lazy ^\.\/.*\.entry\.js$ include: \.entry\.js$ exclude: \.system\.entry\.js$ namespace object ***!
  \*****************************************************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-action-sheet-controller_8.entry.js",
		"common",
		0
	],
	"./ion-action-sheet-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-action-sheet-ios.entry.js",
		"common",
		1
	],
	"./ion-action-sheet-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-action-sheet-md.entry.js",
		"common",
		2
	],
	"./ion-alert-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-alert-ios.entry.js",
		"common",
		3
	],
	"./ion-alert-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-alert-md.entry.js",
		"common",
		4
	],
	"./ion-app_8-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-app_8-ios.entry.js",
		"common",
		5
	],
	"./ion-app_8-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-app_8-md.entry.js",
		"common",
		6
	],
	"./ion-avatar_3-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-avatar_3-ios.entry.js",
		"common",
		7
	],
	"./ion-avatar_3-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-avatar_3-md.entry.js",
		"common",
		8
	],
	"./ion-back-button-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-back-button-ios.entry.js",
		"common",
		9
	],
	"./ion-back-button-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-back-button-md.entry.js",
		"common",
		10
	],
	"./ion-backdrop-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-backdrop-ios.entry.js",
		11
	],
	"./ion-backdrop-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-backdrop-md.entry.js",
		12
	],
	"./ion-button_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-button_2-ios.entry.js",
		"common",
		13
	],
	"./ion-button_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-button_2-md.entry.js",
		"common",
		14
	],
	"./ion-card_5-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-card_5-ios.entry.js",
		"common",
		15
	],
	"./ion-card_5-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-card_5-md.entry.js",
		"common",
		16
	],
	"./ion-checkbox-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-checkbox-ios.entry.js",
		"common",
		17
	],
	"./ion-checkbox-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-checkbox-md.entry.js",
		"common",
		18
	],
	"./ion-chip-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-chip-ios.entry.js",
		"common",
		19
	],
	"./ion-chip-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-chip-md.entry.js",
		"common",
		20
	],
	"./ion-col_3.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-col_3.entry.js",
		21
	],
	"./ion-datetime_3-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-datetime_3-ios.entry.js",
		"common",
		22
	],
	"./ion-datetime_3-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-datetime_3-md.entry.js",
		"common",
		23
	],
	"./ion-fab_3-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-fab_3-ios.entry.js",
		"common",
		24
	],
	"./ion-fab_3-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-fab_3-md.entry.js",
		"common",
		25
	],
	"./ion-img.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-img.entry.js",
		26
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-infinite-scroll_2-ios.entry.js",
		"common",
		27
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-infinite-scroll_2-md.entry.js",
		"common",
		28
	],
	"./ion-input-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-input-ios.entry.js",
		"common",
		29
	],
	"./ion-input-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-input-md.entry.js",
		"common",
		30
	],
	"./ion-item-option_3-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-item-option_3-ios.entry.js",
		"common",
		31
	],
	"./ion-item-option_3-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-item-option_3-md.entry.js",
		"common",
		32
	],
	"./ion-item_8-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-item_8-ios.entry.js",
		"common",
		33
	],
	"./ion-item_8-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-item_8-md.entry.js",
		"common",
		34
	],
	"./ion-loading-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-loading-ios.entry.js",
		"common",
		35
	],
	"./ion-loading-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-loading-md.entry.js",
		"common",
		36
	],
	"./ion-menu_4-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-menu_4-ios.entry.js",
		"common",
		37
	],
	"./ion-menu_4-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-menu_4-md.entry.js",
		"common",
		38
	],
	"./ion-modal-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-modal-ios.entry.js",
		"common",
		39
	],
	"./ion-modal-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-modal-md.entry.js",
		"common",
		40
	],
	"./ion-nav_5.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-nav_5.entry.js",
		"common",
		41
	],
	"./ion-popover-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-popover-ios.entry.js",
		"common",
		42
	],
	"./ion-popover-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-popover-md.entry.js",
		"common",
		43
	],
	"./ion-progress-bar-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-progress-bar-ios.entry.js",
		"common",
		44
	],
	"./ion-progress-bar-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-progress-bar-md.entry.js",
		"common",
		45
	],
	"./ion-radio_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-radio_2-ios.entry.js",
		"common",
		46
	],
	"./ion-radio_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-radio_2-md.entry.js",
		"common",
		47
	],
	"./ion-range-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-range-ios.entry.js",
		"common",
		48
	],
	"./ion-range-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-range-md.entry.js",
		"common",
		49
	],
	"./ion-refresher_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-refresher_2-ios.entry.js",
		"common",
		50
	],
	"./ion-refresher_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-refresher_2-md.entry.js",
		"common",
		51
	],
	"./ion-reorder_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-reorder_2-ios.entry.js",
		"common",
		52
	],
	"./ion-reorder_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-reorder_2-md.entry.js",
		"common",
		53
	],
	"./ion-ripple-effect.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-ripple-effect.entry.js",
		54
	],
	"./ion-route_4.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-route_4.entry.js",
		"common",
		55
	],
	"./ion-searchbar-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-searchbar-ios.entry.js",
		"common",
		56
	],
	"./ion-searchbar-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-searchbar-md.entry.js",
		"common",
		57
	],
	"./ion-segment_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-segment_2-ios.entry.js",
		"common",
		58
	],
	"./ion-segment_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-segment_2-md.entry.js",
		"common",
		59
	],
	"./ion-select_3-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-select_3-ios.entry.js",
		"common",
		60
	],
	"./ion-select_3-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-select_3-md.entry.js",
		"common",
		61
	],
	"./ion-slide_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-slide_2-ios.entry.js",
		62
	],
	"./ion-slide_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-slide_2-md.entry.js",
		63
	],
	"./ion-spinner.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-spinner.entry.js",
		"common",
		64
	],
	"./ion-split-pane-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-split-pane-ios.entry.js",
		65
	],
	"./ion-split-pane-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-split-pane-md.entry.js",
		66
	],
	"./ion-tab-bar_2-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-tab-bar_2-ios.entry.js",
		"common",
		67
	],
	"./ion-tab-bar_2-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-tab-bar_2-md.entry.js",
		"common",
		68
	],
	"./ion-tab_2.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-tab_2.entry.js",
		"common",
		69
	],
	"./ion-text.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-text.entry.js",
		"common",
		70
	],
	"./ion-textarea-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-textarea-ios.entry.js",
		"common",
		71
	],
	"./ion-textarea-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-textarea-md.entry.js",
		"common",
		72
	],
	"./ion-toast-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-toast-ios.entry.js",
		"common",
		73
	],
	"./ion-toast-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-toast-md.entry.js",
		"common",
		74
	],
	"./ion-toggle-ios.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-toggle-ios.entry.js",
		"common",
		75
	],
	"./ion-toggle-md.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-toggle-md.entry.js",
		"common",
		76
	],
	"./ion-virtual-scroll.entry.js": [
		"./node_modules/@ionic/core/dist/esm/ion-virtual-scroll.entry.js",
		77
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./node_modules/@ionic/core/dist/esm lazy recursive ^\\.\\/.*\\.entry\\.js$ include: \\.entry\\.js$ exclude: \\.system\\.entry\\.js$";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @services/auth/auth-guard.service */ "./src/app/services/auth/auth-guard.service.ts");




const routes = [
    { path: '', redirectTo: 'private/main', pathMatch: 'full' },
    {
        path: 'login',
        loadChildren: () => __webpack_require__.e(/*! import() | public-login-login-module */ "public-login-login-module").then(__webpack_require__.bind(null, /*! ./public/login/login.module */ "./src/app/public/login/login.module.ts")).then(m => m.LoginPageModule),
    },
    {
        path: 'private',
        canActivate: [_services_auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_3__["AuthGuardService"]],
        loadChildren: () => __webpack_require__.e(/*! import() | private-private-routing-module */ "private-private-routing-module").then(__webpack_require__.bind(null, /*! ./private/private-routing.module */ "./src/app/private/private-routing.module.ts")).then(m => m.PrivateRoutingModule),
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { preloadingStrategy: _angular_router__WEBPACK_IMPORTED_MODULE_2__["PreloadAllModules"] }),
        ],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]],
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ionic_angular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ionic/angular */ "./node_modules/@ionic/angular/dist/fesm5.js");
/* harmony import */ var _ionic_native_splash_screen_ngx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ionic-native/splash-screen/ngx */ "./node_modules/@ionic-native/splash-screen/ngx/index.js");
/* harmony import */ var _ionic_native_status_bar_ngx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ionic-native/status-bar/ngx */ "./node_modules/@ionic-native/status-bar/ngx/index.js");
/* harmony import */ var _services_auth_authentication_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/auth/authentication.service */ "./src/app/services/auth/authentication.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _state_equipment_equipment_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./state/equipment/equipment.actions */ "./src/app/state/equipment/equipment.actions.ts");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./models */ "./src/app/models/index.ts");
/* harmony import */ var _state_user_me_user_me_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./state/user-me/user-me.actions */ "./src/app/state/user-me/user-me.actions.ts");











let AppComponent = class AppComponent {
    constructor(platform, splashScreen, statusBar, authService, store$) {
        this.platform = platform;
        this.splashScreen = splashScreen;
        this.statusBar = statusBar;
        this.authService = authService;
        this.store$ = store$;
        this.initializeApp();
    }
    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
            this.subs = this.authService.authenticationState.subscribe(authState => {
                if (authState.authenticated) {
                    this.store$.dispatch(Object(_state_user_me_user_me_actions__WEBPACK_IMPORTED_MODULE_10__["loadUserMe"])());
                    this.store$.dispatch(Object(_state_equipment_equipment_actions__WEBPACK_IMPORTED_MODULE_7__["loadAllEquipment"])());
                    this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_8__["LoadAll"](_models__WEBPACK_IMPORTED_MODULE_9__["User"]));
                    this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_8__["LoadAll"](_models__WEBPACK_IMPORTED_MODULE_9__["UserRole"]));
                }
            });
        });
    }
};
AppComponent.ctorParameters = () => [
    { type: _ionic_angular__WEBPACK_IMPORTED_MODULE_2__["Platform"] },
    { type: _ionic_native_splash_screen_ngx__WEBPACK_IMPORTED_MODULE_3__["SplashScreen"] },
    { type: _ionic_native_status_bar_ngx__WEBPACK_IMPORTED_MODULE_4__["StatusBar"] },
    { type: _services_auth_authentication_service__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ionic_angular__WEBPACK_IMPORTED_MODULE_2__["Platform"],
        _ionic_native_splash_screen_ngx__WEBPACK_IMPORTED_MODULE_3__["SplashScreen"],
        _ionic_native_status_bar_ngx__WEBPACK_IMPORTED_MODULE_4__["StatusBar"],
        _services_auth_authentication_service__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ionic_angular__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ionic/angular */ "./node_modules/@ionic/angular/dist/fesm5.js");
/* harmony import */ var _ionic_native_splash_screen_ngx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ionic-native/splash-screen/ngx */ "./node_modules/@ionic-native/splash-screen/ngx/index.js");
/* harmony import */ var _ionic_native_status_bar_ngx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ionic-native/status-bar/ngx */ "./node_modules/@ionic-native/status-bar/ngx/index.js");
/* harmony import */ var ngx_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ngx-perfect-scrollbar */ "./node_modules/ngx-perfect-scrollbar/dist/ngx-perfect-scrollbar.es5.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _ionic_storage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @ionic/storage */ "./node_modules/@ionic/storage/fesm2015/ionic-storage.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var ngx_date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ngx-date-fns */ "./node_modules/ngx-date-fns/fesm2015/ngx-date-fns.js");
/* harmony import */ var _fortawesome_angular_fontawesome__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @fortawesome/angular-fontawesome */ "./node_modules/@fortawesome/angular-fontawesome/fesm2015/angular-fontawesome.js");
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @fortawesome/free-solid-svg-icons */ "./node_modules/@fortawesome/free-solid-svg-icons/index.es.js");
/* harmony import */ var _fortawesome_free_regular_svg_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @fortawesome/free-regular-svg-icons */ "./node_modules/@fortawesome/free-regular-svg-icons/index.es.js");
/* harmony import */ var _state_state_module__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./state/state.module */ "./src/app/state/state.module.ts");
/* harmony import */ var _models_equipment_class_model__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./models/equipment-class.model */ "./src/app/models/equipment-class.model.ts");
/* harmony import */ var _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @services/api/mapped-entity.service */ "./src/app/services/api/mapped-entity.service.ts");
/* harmony import */ var _services_api_api_interceptor_service__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @services/api/api-interceptor.service */ "./src/app/services/api/api-interceptor.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./models */ "./src/app/models/index.ts");
/* harmony import */ var _services_api_trucking_move_service__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @services/api/trucking-move.service */ "./src/app/services/api/trucking-move.service.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
























let AppModule = class AppModule {
    constructor(library) {
        library.addIconPacks(_fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_14__["fas"], _fortawesome_free_regular_svg_icons__WEBPACK_IMPORTED_MODULE_15__["far"]);
    }
};
AppModule.ctorParameters = () => [
    { type: _fortawesome_angular_fontawesome__WEBPACK_IMPORTED_MODULE_13__["FaIconLibrary"] }
];
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"]],
        entryComponents: [],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_23__["BrowserAnimationsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_11__["HttpClientModule"],
            _ionic_angular__WEBPACK_IMPORTED_MODULE_4__["IonicModule"].forRoot({ mode: 'md' }),
            _ionic_storage__WEBPACK_IMPORTED_MODULE_10__["IonicStorageModule"].forRoot(),
            ngx_date_fns__WEBPACK_IMPORTED_MODULE_12__["DateFnsModule"].forRoot(),
            _angular_forms__WEBPACK_IMPORTED_MODULE_20__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_20__["ReactiveFormsModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_9__["AppRoutingModule"],
            _fortawesome_angular_fontawesome__WEBPACK_IMPORTED_MODULE_13__["FontAwesomeModule"],
            _state_state_module__WEBPACK_IMPORTED_MODULE_16__["StateModule"],
            ngx_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_7__["PerfectScrollbarModule"],
        ],
        providers: [
            _ionic_native_status_bar_ngx__WEBPACK_IMPORTED_MODULE_6__["StatusBar"],
            _ionic_native_splash_screen_ngx__WEBPACK_IMPORTED_MODULE_5__["SplashScreen"],
            {
                provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_11__["HTTP_INTERCEPTORS"],
                useClass: _services_api_api_interceptor_service__WEBPACK_IMPORTED_MODULE_19__["ApiInterceptorService"],
                multi: true,
            },
            { provide: _angular_router__WEBPACK_IMPORTED_MODULE_3__["RouteReuseStrategy"], useClass: _ionic_angular__WEBPACK_IMPORTED_MODULE_4__["IonicRouteStrategy"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["Crew"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models_equipment_class_model__WEBPACK_IMPORTED_MODULE_17__["EquipmentClass"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentType"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentModel"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentMachine"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentOption"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentOptionType"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentUntrackedClass"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["EquipmentUntrackedMachine"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["Job"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobEquipment"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobPlan"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobPlanCrewRequirement"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobPlanCrewAssignment"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobPlanManager"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["MaterialCategory"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["MaterialVendor"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["RestorationCategory"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["RestorationType"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["RestorationVendor"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["SubcontractorCategory"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["SubcontractorVendor"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["User"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["UserRole"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["ImportStatus"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["Vendor"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["TruckingRequirement"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["TruckingMove"], useClass: _services_api_trucking_move_service__WEBPACK_IMPORTED_MODULE_22__["TruckingMoveService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["TruckingEquipLocation"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobLocate"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
            { provide: _models__WEBPACK_IMPORTED_MODULE_21__["JobPlanTentative"], useClass: _services_api_mapped_entity_service__WEBPACK_IMPORTED_MODULE_18__["MappedEntityService"] },
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_8__["AppComponent"]],
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_fortawesome_angular_fontawesome__WEBPACK_IMPORTED_MODULE_13__["FaIconLibrary"]])
], AppModule);



/***/ }),

/***/ "./src/app/models/crew.model.ts":
/*!**************************************!*\
  !*** ./src/app/models/crew.model.ts ***!
  \**************************************/
/*! exports provided: Crew, crewVMToCrew */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Crew", function() { return Crew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "crewVMToCrew", function() { return crewVMToCrew; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class Crew {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], Crew.prototype, "id", void 0);
const crewVMToCrew = (cvm) => {
    return Object.assign({}, cvm, { members: cvm.members.map(member => (Object.assign({}, member, { user: member.user.id }))) });
};


/***/ }),

/***/ "./src/app/models/equipment-class.model.ts":
/*!*************************************************!*\
  !*** ./src/app/models/equipment-class.model.ts ***!
  \*************************************************/
/*! exports provided: EquipmentClass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentClass", function() { return EquipmentClass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class EquipmentClass {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentClass.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/equipment-machine.model.ts":
/*!***************************************************!*\
  !*** ./src/app/models/equipment-machine.model.ts ***!
  \***************************************************/
/*! exports provided: EquipMachineBillingMap, EquipmentMachine */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipMachineBillingMap", function() { return EquipMachineBillingMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentMachine", function() { return EquipmentMachine; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


const EquipMachineBillingMap = {
    HR: 'Hourly',
    DY: 'Daily',
};
class EquipmentMachine {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentMachine.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/equipment-model.model.ts":
/*!*************************************************!*\
  !*** ./src/app/models/equipment-model.model.ts ***!
  \*************************************************/
/*! exports provided: EquipmentModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentModel", function() { return EquipmentModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class EquipmentModel {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentModel.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/equipment-option-type.model.ts":
/*!*******************************************************!*\
  !*** ./src/app/models/equipment-option-type.model.ts ***!
  \*******************************************************/
/*! exports provided: EquipmentOptionType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentOptionType", function() { return EquipmentOptionType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class EquipmentOptionType {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentOptionType.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/equipment-option.model.ts":
/*!**************************************************!*\
  !*** ./src/app/models/equipment-option.model.ts ***!
  \**************************************************/
/*! exports provided: HourlyCalcMap, EquipmentOption */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HourlyCalcMap", function() { return HourlyCalcMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentOption", function() { return EquipmentOption; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


const HourlyCalcMap = {
    ADD: 'Add to parent hours',
    REP: 'Replace parent hours',
};
class EquipmentOption {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentOption.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/equipment-type.model.ts":
/*!************************************************!*\
  !*** ./src/app/models/equipment-type.model.ts ***!
  \************************************************/
/*! exports provided: TransportTypeMap, BillingTypeMap, EquipmentType, EquipmentTypeVM */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TransportTypeMap", function() { return TransportTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingTypeMap", function() { return BillingTypeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentType", function() { return EquipmentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentTypeVM", function() { return EquipmentTypeVM; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


const TransportTypeMap = {
    TR: 'Trucking',
    MS: 'Self-Serve',
};
const BillingTypeMap = {
    HR: 'Hourly',
    DY: 'Daily',
};
class EquipmentType {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentType.prototype, "id", void 0);
class EquipmentTypeVM {
}


/***/ }),

/***/ "./src/app/models/equipment-untracked-class.model.ts":
/*!***********************************************************!*\
  !*** ./src/app/models/equipment-untracked-class.model.ts ***!
  \***********************************************************/
/*! exports provided: EquipmentUntrackedClass */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentUntrackedClass", function() { return EquipmentUntrackedClass; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class EquipmentUntrackedClass {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentUntrackedClass.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/equipment-untracked-machine.model.ts":
/*!*************************************************************!*\
  !*** ./src/app/models/equipment-untracked-machine.model.ts ***!
  \*************************************************************/
/*! exports provided: EquipmentUntrackedMachine */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentUntrackedMachine", function() { return EquipmentUntrackedMachine; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class EquipmentUntrackedMachine {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], EquipmentUntrackedMachine.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/import-status.model.ts":
/*!***********************************************!*\
  !*** ./src/app/models/import-status.model.ts ***!
  \***********************************************/
/*! exports provided: ImportStatus */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImportStatus", function() { return ImportStatus; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class ImportStatus {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], ImportStatus.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/index.ts":
/*!*********************************!*\
  !*** ./src/app/models/index.ts ***!
  \*********************************/
/*! exports provided: EquipmentClass, Crew, crewVMToCrew, EquipMachineBillingMap, EquipmentMachine, EquipmentModel, EquipmentOptionType, HourlyCalcMap, EquipmentOption, TransportTypeMap, BillingTypeMap, EquipmentType, EquipmentTypeVM, EquipmentUntrackedClass, EquipmentUntrackedMachine, ImportStatus, Job, JobEquipment, JobLocate, jobPlanVMToJP, JobPlan, JobPlanCrewRequirement, JobPlanCrewRequirementVM, JobPlanCrewAssignment, JobPlanEquipReq, JobPlanManaged, JobPlanManager, JobPlanTentative, Materials, MaterialCategory, MaterialVendor, Restoration, RestorationCategory, restorationTypeValueList, restorationTypeValueMap, RestorationType, RestorationVendor, Subcontractors, SubcontractorCategory, SubcontractorVendor, TruckingMove, TruckingMoveDetails, TruckingRequirement, TruckingEquipLocation, User, UserRole, UserTimecard, Vendor, VendorApiPage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _crew_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./crew.model */ "./src/app/models/crew.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Crew", function() { return _crew_model__WEBPACK_IMPORTED_MODULE_1__["Crew"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "crewVMToCrew", function() { return _crew_model__WEBPACK_IMPORTED_MODULE_1__["crewVMToCrew"]; });

/* harmony import */ var _equipment_class_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./equipment-class.model */ "./src/app/models/equipment-class.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentClass", function() { return _equipment_class_model__WEBPACK_IMPORTED_MODULE_2__["EquipmentClass"]; });

/* harmony import */ var _equipment_machine_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./equipment-machine.model */ "./src/app/models/equipment-machine.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipMachineBillingMap", function() { return _equipment_machine_model__WEBPACK_IMPORTED_MODULE_3__["EquipMachineBillingMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentMachine", function() { return _equipment_machine_model__WEBPACK_IMPORTED_MODULE_3__["EquipmentMachine"]; });

/* harmony import */ var _equipment_model_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./equipment-model.model */ "./src/app/models/equipment-model.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentModel", function() { return _equipment_model_model__WEBPACK_IMPORTED_MODULE_4__["EquipmentModel"]; });

/* harmony import */ var _equipment_option_type_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./equipment-option-type.model */ "./src/app/models/equipment-option-type.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentOptionType", function() { return _equipment_option_type_model__WEBPACK_IMPORTED_MODULE_5__["EquipmentOptionType"]; });

/* harmony import */ var _equipment_option_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./equipment-option.model */ "./src/app/models/equipment-option.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HourlyCalcMap", function() { return _equipment_option_model__WEBPACK_IMPORTED_MODULE_6__["HourlyCalcMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentOption", function() { return _equipment_option_model__WEBPACK_IMPORTED_MODULE_6__["EquipmentOption"]; });

/* harmony import */ var _equipment_type_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./equipment-type.model */ "./src/app/models/equipment-type.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TransportTypeMap", function() { return _equipment_type_model__WEBPACK_IMPORTED_MODULE_7__["TransportTypeMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BillingTypeMap", function() { return _equipment_type_model__WEBPACK_IMPORTED_MODULE_7__["BillingTypeMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentType", function() { return _equipment_type_model__WEBPACK_IMPORTED_MODULE_7__["EquipmentType"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentTypeVM", function() { return _equipment_type_model__WEBPACK_IMPORTED_MODULE_7__["EquipmentTypeVM"]; });

/* harmony import */ var _equipment_untracked_class_model__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./equipment-untracked-class.model */ "./src/app/models/equipment-untracked-class.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentUntrackedClass", function() { return _equipment_untracked_class_model__WEBPACK_IMPORTED_MODULE_8__["EquipmentUntrackedClass"]; });

/* harmony import */ var _equipment_untracked_machine_model__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./equipment-untracked-machine.model */ "./src/app/models/equipment-untracked-machine.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EquipmentUntrackedMachine", function() { return _equipment_untracked_machine_model__WEBPACK_IMPORTED_MODULE_9__["EquipmentUntrackedMachine"]; });

/* harmony import */ var _import_status_model__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./import-status.model */ "./src/app/models/import-status.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImportStatus", function() { return _import_status_model__WEBPACK_IMPORTED_MODULE_10__["ImportStatus"]; });

/* harmony import */ var _job_model__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./job.model */ "./src/app/models/job.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Job", function() { return _job_model__WEBPACK_IMPORTED_MODULE_11__["Job"]; });

/* harmony import */ var _job_equipment_model__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./job-equipment.model */ "./src/app/models/job-equipment.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobEquipment", function() { return _job_equipment_model__WEBPACK_IMPORTED_MODULE_12__["JobEquipment"]; });

/* harmony import */ var _job_locate_model__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./job-locate.model */ "./src/app/models/job-locate.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobLocate", function() { return _job_locate_model__WEBPACK_IMPORTED_MODULE_13__["JobLocate"]; });

/* harmony import */ var _job_plan_model__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./job-plan.model */ "./src/app/models/job-plan.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "jobPlanVMToJP", function() { return _job_plan_model__WEBPACK_IMPORTED_MODULE_14__["jobPlanVMToJP"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlan", function() { return _job_plan_model__WEBPACK_IMPORTED_MODULE_14__["JobPlan"]; });

/* harmony import */ var _job_plan_crew_requirement_model__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./job-plan-crew-requirement.model */ "./src/app/models/job-plan-crew-requirement.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewRequirement", function() { return _job_plan_crew_requirement_model__WEBPACK_IMPORTED_MODULE_15__["JobPlanCrewRequirement"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewRequirementVM", function() { return _job_plan_crew_requirement_model__WEBPACK_IMPORTED_MODULE_15__["JobPlanCrewRequirementVM"]; });

/* harmony import */ var _job_plan_crew_assignment_model__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./job-plan-crew-assignment.model */ "./src/app/models/job-plan-crew-assignment.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewAssignment", function() { return _job_plan_crew_assignment_model__WEBPACK_IMPORTED_MODULE_16__["JobPlanCrewAssignment"]; });

/* harmony import */ var _job_plan_equip_req_model__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./job-plan-equip-req.model */ "./src/app/models/job-plan-equip-req.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanEquipReq", function() { return _job_plan_equip_req_model__WEBPACK_IMPORTED_MODULE_17__["JobPlanEquipReq"]; });

/* harmony import */ var _job_plan_managed_model__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./job-plan-managed.model */ "./src/app/models/job-plan-managed.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanManaged", function() { return _job_plan_managed_model__WEBPACK_IMPORTED_MODULE_18__["JobPlanManaged"]; });

/* harmony import */ var _job_plan_manager_model__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./job-plan-manager.model */ "./src/app/models/job-plan-manager.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanManager", function() { return _job_plan_manager_model__WEBPACK_IMPORTED_MODULE_19__["JobPlanManager"]; });

/* harmony import */ var _job_plan_tentative_model__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./job-plan-tentative.model */ "./src/app/models/job-plan-tentative.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JobPlanTentative", function() { return _job_plan_tentative_model__WEBPACK_IMPORTED_MODULE_20__["JobPlanTentative"]; });

/* harmony import */ var _materials_model__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./materials.model */ "./src/app/models/materials.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Materials", function() { return _materials_model__WEBPACK_IMPORTED_MODULE_21__["Materials"]; });

/* harmony import */ var _material_category_model__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./material-category.model */ "./src/app/models/material-category.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MaterialCategory", function() { return _material_category_model__WEBPACK_IMPORTED_MODULE_22__["MaterialCategory"]; });

/* harmony import */ var _material_vendor_model__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./material-vendor.model */ "./src/app/models/material-vendor.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MaterialVendor", function() { return _material_vendor_model__WEBPACK_IMPORTED_MODULE_23__["MaterialVendor"]; });

/* harmony import */ var _restoration_model__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./restoration.model */ "./src/app/models/restoration.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Restoration", function() { return _restoration_model__WEBPACK_IMPORTED_MODULE_24__["Restoration"]; });

/* harmony import */ var _restoration_category_model__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./restoration-category.model */ "./src/app/models/restoration-category.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RestorationCategory", function() { return _restoration_category_model__WEBPACK_IMPORTED_MODULE_25__["RestorationCategory"]; });

/* harmony import */ var _restoration_type_model__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./restoration-type.model */ "./src/app/models/restoration-type.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "restorationTypeValueList", function() { return _restoration_type_model__WEBPACK_IMPORTED_MODULE_26__["restorationTypeValueList"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "restorationTypeValueMap", function() { return _restoration_type_model__WEBPACK_IMPORTED_MODULE_26__["restorationTypeValueMap"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RestorationType", function() { return _restoration_type_model__WEBPACK_IMPORTED_MODULE_26__["RestorationType"]; });

/* harmony import */ var _restoration_vendor_model__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./restoration-vendor.model */ "./src/app/models/restoration-vendor.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RestorationVendor", function() { return _restoration_vendor_model__WEBPACK_IMPORTED_MODULE_27__["RestorationVendor"]; });

/* harmony import */ var _subcontractors_model__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./subcontractors.model */ "./src/app/models/subcontractors.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subcontractors", function() { return _subcontractors_model__WEBPACK_IMPORTED_MODULE_28__["Subcontractors"]; });

/* harmony import */ var _subcontractor_category_model__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./subcontractor-category.model */ "./src/app/models/subcontractor-category.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SubcontractorCategory", function() { return _subcontractor_category_model__WEBPACK_IMPORTED_MODULE_29__["SubcontractorCategory"]; });

/* harmony import */ var _subcontractor_vendor_model__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./subcontractor-vendor.model */ "./src/app/models/subcontractor-vendor.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SubcontractorVendor", function() { return _subcontractor_vendor_model__WEBPACK_IMPORTED_MODULE_30__["SubcontractorVendor"]; });

/* harmony import */ var _trucking_move_model__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./trucking-move.model */ "./src/app/models/trucking-move.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TruckingMove", function() { return _trucking_move_model__WEBPACK_IMPORTED_MODULE_31__["TruckingMove"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TruckingMoveDetails", function() { return _trucking_move_model__WEBPACK_IMPORTED_MODULE_31__["TruckingMoveDetails"]; });

/* harmony import */ var _trucking_requirement_model__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./trucking-requirement.model */ "./src/app/models/trucking-requirement.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TruckingRequirement", function() { return _trucking_requirement_model__WEBPACK_IMPORTED_MODULE_32__["TruckingRequirement"]; });

/* harmony import */ var _trucking_equip_location_model__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./trucking-equip-location.model */ "./src/app/models/trucking-equip-location.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TruckingEquipLocation", function() { return _trucking_equip_location_model__WEBPACK_IMPORTED_MODULE_33__["TruckingEquipLocation"]; });

/* harmony import */ var _user_model__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./user.model */ "./src/app/models/user.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "User", function() { return _user_model__WEBPACK_IMPORTED_MODULE_34__["User"]; });

/* harmony import */ var _user_role_model__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./user-role.model */ "./src/app/models/user-role.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UserRole", function() { return _user_role_model__WEBPACK_IMPORTED_MODULE_35__["UserRole"]; });

/* harmony import */ var _user_timecard_model__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./user-timecard.model */ "./src/app/models/user-timecard.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UserTimecard", function() { return _user_timecard_model__WEBPACK_IMPORTED_MODULE_36__["UserTimecard"]; });

/* harmony import */ var _vendor_model__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./vendor.model */ "./src/app/models/vendor.model.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vendor", function() { return _vendor_model__WEBPACK_IMPORTED_MODULE_37__["Vendor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VendorApiPage", function() { return _vendor_model__WEBPACK_IMPORTED_MODULE_37__["VendorApiPage"]; });









































/***/ }),

/***/ "./src/app/models/job-equipment.model.ts":
/*!***********************************************!*\
  !*** ./src/app/models/job-equipment.model.ts ***!
  \***********************************************/
/*! exports provided: JobEquipment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobEquipment", function() { return JobEquipment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobEquipment {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobEquipment.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job-locate.model.ts":
/*!********************************************!*\
  !*** ./src/app/models/job-locate.model.ts ***!
  \********************************************/
/*! exports provided: JobLocate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobLocate", function() { return JobLocate; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobLocate {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobLocate.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job-plan-crew-assignment.model.ts":
/*!**********************************************************!*\
  !*** ./src/app/models/job-plan-crew-assignment.model.ts ***!
  \**********************************************************/
/*! exports provided: JobPlanCrewAssignment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewAssignment", function() { return JobPlanCrewAssignment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobPlanCrewAssignment {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlanCrewAssignment.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job-plan-crew-requirement.model.ts":
/*!***********************************************************!*\
  !*** ./src/app/models/job-plan-crew-requirement.model.ts ***!
  \***********************************************************/
/*! exports provided: JobPlanCrewRequirement, JobPlanCrewRequirementVM */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewRequirement", function() { return JobPlanCrewRequirement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewRequirementVM", function() { return JobPlanCrewRequirementVM; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobPlanCrewRequirement {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlanCrewRequirement.prototype, "id", void 0);
class JobPlanCrewRequirementVM {
}


/***/ }),

/***/ "./src/app/models/job-plan-equip-req.model.ts":
/*!****************************************************!*\
  !*** ./src/app/models/job-plan-equip-req.model.ts ***!
  \****************************************************/
/*! exports provided: JobPlanEquipReq */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanEquipReq", function() { return JobPlanEquipReq; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobPlanEquipReq {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlanEquipReq.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job-plan-managed.model.ts":
/*!**************************************************!*\
  !*** ./src/app/models/job-plan-managed.model.ts ***!
  \**************************************************/
/*! exports provided: JobPlanManaged */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanManaged", function() { return JobPlanManaged; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobPlanManaged {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlanManaged.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job-plan-manager.model.ts":
/*!**************************************************!*\
  !*** ./src/app/models/job-plan-manager.model.ts ***!
  \**************************************************/
/*! exports provided: JobPlanManager */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanManager", function() { return JobPlanManager; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobPlanManager {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlanManager.prototype, "manager", void 0);


/***/ }),

/***/ "./src/app/models/job-plan-tentative.model.ts":
/*!****************************************************!*\
  !*** ./src/app/models/job-plan-tentative.model.ts ***!
  \****************************************************/
/*! exports provided: JobPlanTentative */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanTentative", function() { return JobPlanTentative; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class JobPlanTentative {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlanTentative.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job-plan.model.ts":
/*!******************************************!*\
  !*** ./src/app/models/job-plan.model.ts ***!
  \******************************************/
/*! exports provided: jobPlanVMToJP, JobPlan */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanVMToJP", function() { return jobPlanVMToJP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlan", function() { return JobPlan; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! date-fns */ "./node_modules/date-fns/esm/index.js");



const jobPlanVMToJP = (jp) => {
    return Object.assign({}, jp, { job: jp.job.id, start: Object(date_fns__WEBPACK_IMPORTED_MODULE_2__["format"])(jp.start, 'yyyy-MM-dd'), end: Object(date_fns__WEBPACK_IMPORTED_MODULE_2__["format"])(jp.end, 'yyyy-MM-dd'), completedDate: jp.completedDate
            ? Object(date_fns__WEBPACK_IMPORTED_MODULE_2__["format"])(jp.completedDate, 'yyyy-MM-dd')
            : null, datesStatus: jp.datesStatus.map(ds => (Object.assign({}, ds, { date: Object(date_fns__WEBPACK_IMPORTED_MODULE_2__["format"])(ds.date, 'yyyy-MM-dd') }))) });
};
class JobPlan {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JobPlan.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/job.model.ts":
/*!*************************************!*\
  !*** ./src/app/models/job.model.ts ***!
  \*************************************/
/*! exports provided: Job */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Job", function() { return Job; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class Job {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], Job.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/material-category.model.ts":
/*!***************************************************!*\
  !*** ./src/app/models/material-category.model.ts ***!
  \***************************************************/
/*! exports provided: MaterialCategory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialCategory", function() { return MaterialCategory; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class MaterialCategory {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], MaterialCategory.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/material-vendor.model.ts":
/*!*************************************************!*\
  !*** ./src/app/models/material-vendor.model.ts ***!
  \*************************************************/
/*! exports provided: MaterialVendor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialVendor", function() { return MaterialVendor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class MaterialVendor {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], MaterialVendor.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/materials.model.ts":
/*!*******************************************!*\
  !*** ./src/app/models/materials.model.ts ***!
  \*******************************************/
/*! exports provided: Materials */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Materials", function() { return Materials; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Materials {
}


/***/ }),

/***/ "./src/app/models/restoration-category.model.ts":
/*!******************************************************!*\
  !*** ./src/app/models/restoration-category.model.ts ***!
  \******************************************************/
/*! exports provided: RestorationCategory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationCategory", function() { return RestorationCategory; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class RestorationCategory {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], RestorationCategory.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/restoration-type.model.ts":
/*!**************************************************!*\
  !*** ./src/app/models/restoration-type.model.ts ***!
  \**************************************************/
/*! exports provided: restorationTypeValueList, restorationTypeValueMap, RestorationType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationTypeValueList", function() { return restorationTypeValueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationTypeValueMap", function() { return restorationTypeValueMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationType", function() { return RestorationType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


const restorationTypeValueList = [
    { value: 'D1', label: 'Length' },
    { value: 'D2', label: 'Area' },
    { value: 'D3', label: 'Volume' },
    { value: 'NA', label: 'None' },
];
const restorationTypeValueMap = {
    D1: 'Length',
    D2: 'Area',
    D3: 'Volume',
    NA: 'None',
};
class RestorationType {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], RestorationType.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/restoration-vendor.model.ts":
/*!****************************************************!*\
  !*** ./src/app/models/restoration-vendor.model.ts ***!
  \****************************************************/
/*! exports provided: RestorationVendor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationVendor", function() { return RestorationVendor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class RestorationVendor {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], RestorationVendor.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/restoration.model.ts":
/*!*********************************************!*\
  !*** ./src/app/models/restoration.model.ts ***!
  \*********************************************/
/*! exports provided: Restoration */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Restoration", function() { return Restoration; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Restoration {
}


/***/ }),

/***/ "./src/app/models/subcontractor-category.model.ts":
/*!********************************************************!*\
  !*** ./src/app/models/subcontractor-category.model.ts ***!
  \********************************************************/
/*! exports provided: SubcontractorCategory */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubcontractorCategory", function() { return SubcontractorCategory; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class SubcontractorCategory {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], SubcontractorCategory.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/subcontractor-vendor.model.ts":
/*!******************************************************!*\
  !*** ./src/app/models/subcontractor-vendor.model.ts ***!
  \******************************************************/
/*! exports provided: SubcontractorVendor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubcontractorVendor", function() { return SubcontractorVendor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class SubcontractorVendor {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], SubcontractorVendor.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/subcontractors.model.ts":
/*!************************************************!*\
  !*** ./src/app/models/subcontractors.model.ts ***!
  \************************************************/
/*! exports provided: Subcontractors */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subcontractors", function() { return Subcontractors; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Subcontractors {
}


/***/ }),

/***/ "./src/app/models/trucking-equip-location.model.ts":
/*!*********************************************************!*\
  !*** ./src/app/models/trucking-equip-location.model.ts ***!
  \*********************************************************/
/*! exports provided: TruckingEquipLocation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingEquipLocation", function() { return TruckingEquipLocation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class TruckingEquipLocation {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], TruckingEquipLocation.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/trucking-move.model.ts":
/*!***********************************************!*\
  !*** ./src/app/models/trucking-move.model.ts ***!
  \***********************************************/
/*! exports provided: TruckingMove, TruckingMoveDetails */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingMove", function() { return TruckingMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingMoveDetails", function() { return TruckingMoveDetails; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class TruckingMove {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], TruckingMove.prototype, "id", void 0);
class TruckingMoveDetails {
}


/***/ }),

/***/ "./src/app/models/trucking-requirement.model.ts":
/*!******************************************************!*\
  !*** ./src/app/models/trucking-requirement.model.ts ***!
  \******************************************************/
/*! exports provided: TruckingRequirement */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingRequirement", function() { return TruckingRequirement; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class TruckingRequirement {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], TruckingRequirement.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/user-role.model.ts":
/*!*******************************************!*\
  !*** ./src/app/models/user-role.model.ts ***!
  \*******************************************/
/*! exports provided: UserRole */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserRole", function() { return UserRole; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class UserRole {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], UserRole.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/user-timecard.model.ts":
/*!***********************************************!*\
  !*** ./src/app/models/user-timecard.model.ts ***!
  \***********************************************/
/*! exports provided: UserTimecard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserTimecard", function() { return UserTimecard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class UserTimecard {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], UserTimecard.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/user.model.ts":
/*!**************************************!*\
  !*** ./src/app/models/user.model.ts ***!
  \**************************************/
/*! exports provided: User */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "User", function() { return User; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class User {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], User.prototype, "id", void 0);


/***/ }),

/***/ "./src/app/models/vendor.model.ts":
/*!****************************************!*\
  !*** ./src/app/models/vendor.model.ts ***!
  \****************************************/
/*! exports provided: Vendor, VendorApiPage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Vendor", function() { return Vendor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VendorApiPage", function() { return VendorApiPage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");


class Vendor {
}
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["Key"],
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], Vendor.prototype, "id", void 0);
class VendorApiPage {
}


/***/ }),

/***/ "./src/app/services/api/api-interceptor.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/services/api/api-interceptor.service.ts ***!
  \*********************************************************/
/*! exports provided: ApiInterceptorService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiInterceptorService", function() { return ApiInterceptorService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _auth_authentication_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../auth/authentication.service */ "./src/app/services/auth/authentication.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _shared_utils_camelize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @shared/utils/camelize */ "./src/app/shared/utils/camelize.ts");






let ApiInterceptorService = class ApiInterceptorService {
    constructor(authService) {
        this.authService = authService;
        this.token = null;
        this.authSub = this.authService.authenticationState.subscribe(authDat => {
            this.token = authDat.token;
        });
    }
    ngOnDestroy() {
        this.authSub.unsubscribe();
    }
    intercept(request, next) {
        if (this.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Token ${this.token}`,
                },
            });
        }
        const reqBodySnake = Object(_shared_utils_camelize__WEBPACK_IMPORTED_MODULE_5__["snakecaseKeys"])(request.body);
        request = request.clone({ body: reqBodySnake });
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_1__["map"])((event) => {
            if (event instanceof _angular_common_http__WEBPACK_IMPORTED_MODULE_4__["HttpResponse"]) {
                const camelCaseObject = Object(_shared_utils_camelize__WEBPACK_IMPORTED_MODULE_5__["camelizeKeys"])(event.body);
                const modEvent = event.clone({ body: camelCaseObject });
                return modEvent;
            }
            else {
                return event;
            }
        }));
    }
};
ApiInterceptorService.ctorParameters = () => [
    { type: _auth_authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"] }
];
ApiInterceptorService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_auth_authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"]])
], ApiInterceptorService);



/***/ }),

/***/ "./src/app/services/api/api.service.ts":
/*!*********************************************!*\
  !*** ./src/app/services/api/api.service.ts ***!
  \*********************************************/
/*! exports provided: ApiService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return ApiService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ApiService = class ApiService {
    constructor() {
        this.baseUrl = null;
        this.baseWsUrl = null;
        this.pathPrefix = '/api/v1';
        this.wsPathPrefix = '/websockets';
    }
    get url() {
        return `${this.baseUrl}${this.pathPrefix}`;
    }
    set url(url) {
        this.baseUrl = url;
    }
    get wsUrl() {
        return `${this.baseWsUrl}${this.wsPathPrefix}`;
    }
    set wsUrl(url) {
        this.baseWsUrl = url;
    }
};
ApiService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ApiService);



/***/ }),

/***/ "./src/app/services/api/equip.service.ts":
/*!***********************************************!*\
  !*** ./src/app/services/api/equip.service.ts ***!
  \***********************************************/
/*! exports provided: EquipService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipService", function() { return EquipService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let EquipService = class EquipService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    loadAll() {
        return this.http.get(`${this.api.url}/equipment`);
    }
    loadLocations() {
        return this.http.get(`${this.api.url}/equipment/machines/locations`);
    }
};
EquipService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
EquipService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], EquipService);



/***/ }),

/***/ "./src/app/services/api/job-plan.service.ts":
/*!**************************************************!*\
  !*** ./src/app/services/api/job-plan.service.ts ***!
  \**************************************************/
/*! exports provided: JobPlanService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanService", function() { return JobPlanService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");




let JobPlanService = class JobPlanService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    createWithManager(payload) {
        return this.http.post(`${this.api.url}/job-plans`, payload);
    }
    update(entityInfo, entity) {
        return this.http.patch(`${this.api.url}/job-plans/${entity.id}`, entity);
    }
    replace(entityInfo, entity) {
        return this.http.put(`${this.api.url}/job-plans/${entity.id}`, entity);
    }
    getDetails(entity) {
        return this.http.get(`${this.api.url}/job-plans/${entity.id}`);
    }
    createCrewReq(entity) {
        return this.http.post(`${this.api.url}/job-plans/crew-requirements`, entity);
    }
    updateCrewReq(entity) {
        return this.http.put(`${this.api.url}/job-plans/crew-requirements/${entity.id}`, entity);
    }
    deleteCrewReq(entity) {
        return this.http.delete(`${this.api.url}/job-plans/crew-requirements/${entity.id}`);
    }
    createCrewAssignment(entity) {
        return this.http.post(`${this.api.url}/job-plans/crew-assignments`, entity);
    }
    createManyCrewAssignments(entity) {
        return this.http.post(`${this.api.url}/job-plans/crew-assignments`, entity);
    }
    deleteCrewAssignment(entity) {
        return this.http.delete(`${this.api.url}/job-plans/crew-assignments/${entity.id}`);
    }
    createManyEquipReqs(entities) {
        return this.http.post(`${this.api.url}/job-plans/equipment-requirements`, entities);
    }
    updateEquipReq(entity) {
        return this.http.put(`${this.api.url}/job-plans/equipment-requirements/${entity.id}`, entity);
    }
    deleteEquipReq(entity) {
        return this.http.delete(`${this.api.url}/job-plans/equipment-requirements/${entity.id}`);
    }
};
JobPlanService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] }
];
JobPlanService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"]])
], JobPlanService);



/***/ }),

/***/ "./src/app/services/api/job-planner.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/services/api/job-planner.service.ts ***!
  \*****************************************************/
/*! exports provided: JobPlannerService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlannerService", function() { return JobPlannerService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let JobPlannerService = class JobPlannerService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    load(dateParams) {
        return this.http.get(`${this.api.url}/job-plans`, {
            params: { min_date: dateParams.minDate, max_date: dateParams.maxDate },
        });
    }
};
JobPlannerService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
JobPlannerService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], JobPlannerService);



/***/ }),

/***/ "./src/app/services/api/mapped-entity.service.ts":
/*!*******************************************************!*\
  !*** ./src/app/services/api/mapped-entity.service.ts ***!
  \*******************************************************/
/*! exports provided: MappedEntityService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MappedEntityService", function() { return MappedEntityService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");





const urlMap = {
    Crew: 'crews',
    EquipmentClass: 'equipment/classes',
    EquipmentType: 'equipment/types',
    EquipmentModel: 'equipment/models',
    EquipmentMachine: 'equipment/machines',
    EquipmentOption: 'equipment/machine-options',
    EquipmentOptionType: 'equipment/option-types',
    EquipmentUntrackedClass: 'equipment/untracked-classes',
    EquipmentUntrackedMachine: 'equipment/untracked',
    User: 'users',
    UserRole: 'user-roles',
    ImportStatus: 'import-status',
    Job: 'jobs',
    JobEquipment: 'job-equipment',
    JobLocate: 'job-locates',
    JobPlan: 'job-plans',
    JobPlanCrewRequirement: 'job-plans/crew-requirements',
    JobPlanManager: 'job-plans/managers',
    JobPlanCrewAssignment: 'job-plans/crew-assignments',
    JobPlanTentative: 'job-plans/tentative',
    MaterialVendor: 'materials/vendors',
    MaterialCategory: 'materials/categories',
    RestorationCategory: 'restoration/categories',
    RestorationType: 'restoration/types',
    RestorationVendor: 'restoration/vendors',
    SubcontractorVendor: 'subcontractors/vendors',
    SubcontractorCategory: 'subcontractors/categories',
    TruckingMove: 'trucking/moves',
    TruckingRequirement: 'trucking/requirements',
    Vendor: 'vendors',
};
let MappedEntityService = class MappedEntityService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    load(entityInfo, id) {
        return this.http.get(`${this.api.url}/${urlMap[entityInfo.modelName]}/${id}`);
    }
    loadAll(entityInfo) {
        return this.http.get(`${this.api.url}/${urlMap[entityInfo.modelName]}`);
    }
    create(entityInfo, entity) {
        return this.http.post(`${this.api.url}/${urlMap[entityInfo.modelName]}`, entity);
    }
    update(entityInfo, entity) {
        return this.http.patch(`${this.api.url}/${urlMap[entityInfo.modelName]}/${entity.id}`, entity);
    }
    updateMany(entityInfo, entities) {
        return this.http.put(`${this.api.url}/${urlMap[entityInfo.modelName]}`, entities);
    }
    replace(entityInfo, entity) {
        return this.http.put(`${this.api.url}/${urlMap[entityInfo.modelName]}/${entity.id}`, entity);
    }
    delete(entityInfo, entity) {
        return this.http
            .delete(`${this.api.url}/${urlMap[entityInfo.modelName]}/${entity.id}`)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(() => entity));
    }
};
MappedEntityService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_4__["ApiService"] }
];
MappedEntityService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_4__["ApiService"]])
], MappedEntityService);



/***/ }),

/***/ "./src/app/services/api/materials.service.ts":
/*!***************************************************!*\
  !*** ./src/app/services/api/materials.service.ts ***!
  \***************************************************/
/*! exports provided: MaterialsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialsService", function() { return MaterialsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let MaterialsService = class MaterialsService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    loadAll() {
        return this.http.get(`${this.api.url}/materials`);
    }
};
MaterialsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
MaterialsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], MaterialsService);



/***/ }),

/***/ "./src/app/services/api/restoration.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/services/api/restoration.service.ts ***!
  \*****************************************************/
/*! exports provided: RestorationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationService", function() { return RestorationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let RestorationService = class RestorationService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    loadAll() {
        return this.http.get(`${this.api.url}/restoration`);
    }
};
RestorationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
RestorationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], RestorationService);



/***/ }),

/***/ "./src/app/services/api/subcontractors.service.ts":
/*!********************************************************!*\
  !*** ./src/app/services/api/subcontractors.service.ts ***!
  \********************************************************/
/*! exports provided: SubcontractorsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubcontractorsService", function() { return SubcontractorsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let SubcontractorsService = class SubcontractorsService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    loadAll() {
        return this.http.get(`${this.api.url}/subcontractors`);
    }
};
SubcontractorsService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
SubcontractorsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], SubcontractorsService);



/***/ }),

/***/ "./src/app/services/api/trucking-move.service.ts":
/*!*******************************************************!*\
  !*** ./src/app/services/api/trucking-move.service.ts ***!
  \*******************************************************/
/*! exports provided: TruckingMoveService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingMoveService", function() { return TruckingMoveService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let TruckingMoveService = class TruckingMoveService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    load(entityInfo, id) {
        return this.http.get(`${this.api.url}/trucking/moves/${id}`);
    }
    loadAll(entityInfo) {
        return this.http.get(`${this.api.url}/trucking/moves`);
    }
    create(entityInfo, entity) {
        return this.http.post(`${this.api.url}/trucking/moves`, entity);
    }
    update(entityInfo, entity) {
        return this.http.patch(`${this.api.url}/trucking/moves/${entity.id}`, entity);
    }
    updateMany(entityInfo, entities) {
        return this.http.put(`${this.api.url}/trucking/moves`, entities);
    }
    loadMachine(entityInfo, entity) {
        return this.http.patch(`${this.api.url}/trucking/moves/load`, entity);
    }
    unloadMachines(payload) {
        return this.http.patch(`${this.api.url}/trucking/moves/unload`, payload);
    }
    rerouteMachine(payload) {
        return this.http.patch(`${this.api.url}/trucking/moves/reroute`, payload);
    }
    delete(entityInfo, entity) {
        return this.http
            .delete(`${this.api.url}/trucking/moves/${entity.id}`)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(() => entity));
    }
};
TruckingMoveService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
TruckingMoveService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"])({ providedIn: 'root' }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], TruckingMoveService);



/***/ }),

/***/ "./src/app/services/api/trucking.service.ts":
/*!**************************************************!*\
  !*** ./src/app/services/api/trucking.service.ts ***!
  \**************************************************/
/*! exports provided: TruckingService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingService", function() { return TruckingService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");




let TruckingService = class TruckingService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    loadAll() {
        return this.http.get(`${this.api.url}/trucking`);
    }
    loadLocations() {
        return this.http.get(`${this.api.url}/trucking/machines/locations`);
    }
    createTimecard(payload) {
        return this.http.post(`${this.api.url}/trucking/timecards`, payload);
    }
    updateTimecard(payload) {
        return this.http.patch(`${this.api.url}/trucking/timecards/${payload.id}`, payload);
    }
    createRental(payload) {
        return this.http.post(`${this.api.url}/trucking/rentals`, payload);
    }
    planRentalReturn(payload) {
        return this.http.put(`${this.api.url}/trucking/rentals/plan-return`, payload);
    }
    returnRental(payload) {
        return this.http.put(`${this.api.url}/trucking/rentals/return`, payload);
    }
};
TruckingService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
TruckingService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"]])
], TruckingService);



/***/ }),

/***/ "./src/app/services/api/user-me.service.ts":
/*!*************************************************!*\
  !*** ./src/app/services/api/user-me.service.ts ***!
  \*************************************************/
/*! exports provided: UserMeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserMeService", function() { return UserMeService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./api.service */ "./src/app/services/api/api.service.ts");




let UserMeService = class UserMeService {
    constructor(http, api) {
        this.http = http;
        this.api = api;
    }
    load() {
        return this.http.get(`${this.api.url}/users/me`);
    }
};
UserMeService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] }
];
UserMeService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"], _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"]])
], UserMeService);



/***/ }),

/***/ "./src/app/services/auth/auth-guard.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/services/auth/auth-guard.service.ts ***!
  \*****************************************************/
/*! exports provided: AuthGuardService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuardService", function() { return AuthGuardService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _authentication_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./authentication.service */ "./src/app/services/auth/authentication.service.ts");




let AuthGuardService = class AuthGuardService {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    canActivate() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const authStatus = yield this.authService.authenticationStatus();
            if (authStatus.authenticated) {
                return true;
            }
            this.router.navigate(['/login']);
            return false;
        });
    }
};
AuthGuardService.ctorParameters = () => [
    { type: _authentication_service__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AuthGuardService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_authentication_service__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], AuthGuardService);



/***/ }),

/***/ "./src/app/services/auth/authentication.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/services/auth/authentication.service.ts ***!
  \*********************************************************/
/*! exports provided: AuthenticationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return AuthenticationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _api_api_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../api/api.service */ "./src/app/services/api/api.service.ts");
/* harmony import */ var _ionic_angular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ionic/angular */ "./node_modules/@ionic/angular/dist/fesm5.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _ionic_storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ionic/storage */ "./node_modules/@ionic/storage/fesm2015/ionic-storage.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");








const TOKEN_KEY = 'authToken';
const FIRST_LOGIN_KEY = 'firstLogin';
const BASE_URL_KEY = 'baseApiUrl';
const BASE_WS_KEY = 'baseWsUrl';
const ACTIVE_USER_KEY = 'user';
const GATEWAY_URL = src_environments_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].gatewayUrl; // Gateway URL changes depending on build target
let AuthenticationService = class AuthenticationService {
    constructor(storage, plt, http, api) {
        this.storage = storage;
        this.plt = plt;
        this.http = http;
        this.api = api;
        this.authenticationState = new rxjs__WEBPACK_IMPORTED_MODULE_4__["BehaviorSubject"]({
            authenticated: false,
            token: '',
            firstLogin: false,
            baseApiUrl: '',
            baseWsUrl: '',
            user: null,
            loginError: null,
        });
        let readyResolve;
        this.readyPromise = new Promise(res => {
            readyResolve = res;
        });
        this.plt.ready().then(() => {
            this.checkStorage().then(() => {
                readyResolve('ready');
            });
        });
    }
    ready() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.readyPromise;
        });
    }
    login(payload) {
        this.loginSub = this.http.post(GATEWAY_URL, payload).subscribe((data) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const promises = [
                this.storage.set(TOKEN_KEY, data.token),
                this.storage.set(FIRST_LOGIN_KEY, data.firstLogin),
                this.storage.set(BASE_URL_KEY, data.baseApiUrl),
                this.storage.set(ACTIVE_USER_KEY, data.user),
                this.storage.set(BASE_WS_KEY, data.baseWsUrl),
            ];
            const res = yield Promise.all(promises);
            console.log(`setting api url to ${data.baseApiUrl}`);
            console.log(data);
            this.api.url = data.baseApiUrl;
            this.authenticationState.next(Object.assign({ authenticated: true, loginError: null }, data));
        }), error => {
            this.api.url = '';
            this.authenticationState.next({
                authenticated: false,
                token: '',
                firstLogin: false,
                baseApiUrl: '',
                baseWsUrl: '',
                user: null,
                loginError: 'Incorrect Username or Password',
            });
            return null;
        });
    }
    logout() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const promises = [
                this.storage.remove(TOKEN_KEY),
                this.storage.remove(FIRST_LOGIN_KEY),
                this.storage.remove(BASE_URL_KEY),
                this.storage.remove(ACTIVE_USER_KEY),
                this.storage.remove(BASE_WS_KEY),
            ];
            const data = yield Promise.all(promises);
            this.api.url = '';
            this.authenticationState.next({
                authenticated: false,
                token: '',
                firstLogin: false,
                baseApiUrl: '',
                baseWsUrl: '',
                user: null,
                loginError: 'You have been logged out.',
            });
        });
    }
    authenticationStatus() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            yield this.ready();
            return this.authenticationState.value;
        });
    }
    processFirstLogin(newPassword) {
        const authState = this.authenticationState.value;
        this.http
            .patch(this.api.url + `users/${authState.user}/`, {
            password: newPassword,
            first_login: false,
        })
            .subscribe(data => {
            this.storage.set(FIRST_LOGIN_KEY, false).then(() => {
                this.authenticationState.next(Object.assign({}, authState, { firstLogin: false }));
            });
        });
    }
    checkStorage() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const keys = [
                TOKEN_KEY,
                FIRST_LOGIN_KEY,
                BASE_URL_KEY,
                ACTIVE_USER_KEY,
                BASE_WS_KEY,
            ];
            const res = yield this.getMultipleKeys(keys);
            if (res) {
                const auth = TOKEN_KEY in res && res[TOKEN_KEY] ? true : false;
                console.log(`setting api url to ${res[BASE_URL_KEY]}`);
                this.api.url = res[BASE_URL_KEY];
                this.api.wsUrl = res[BASE_WS_KEY];
                const state = {
                    authenticated: auth,
                    token: res[TOKEN_KEY],
                    firstLogin: res[FIRST_LOGIN_KEY],
                    baseApiUrl: res[BASE_URL_KEY],
                    baseWsUrl: res[BASE_WS_KEY],
                    user: res[ACTIVE_USER_KEY],
                    loginError: '',
                };
                this.authenticationState.next(state);
            }
            else {
                this.api.url = '';
                const state = {
                    authenticated: false,
                    token: '',
                    firstLogin: false,
                    baseApiUrl: '',
                    baseWsUrl: '',
                    user: null,
                    loginError: null,
                };
                this.authenticationState.next(state);
            }
        });
    }
    getMultipleKeys(keys) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const promises = [];
            keys.forEach(key => promises.push(this.storage.get(key)));
            const values = yield Promise.all(promises);
            const result = {};
            values.map((value, index) => {
                result[keys[index]] = value;
            });
            return result;
        });
    }
};
AuthenticationService.ctorParameters = () => [
    { type: _ionic_storage__WEBPACK_IMPORTED_MODULE_5__["Storage"] },
    { type: _ionic_angular__WEBPACK_IMPORTED_MODULE_2__["Platform"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"] },
    { type: _api_api_service__WEBPACK_IMPORTED_MODULE_1__["ApiService"] }
];
AuthenticationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ionic_storage__WEBPACK_IMPORTED_MODULE_5__["Storage"],
        _ionic_angular__WEBPACK_IMPORTED_MODULE_2__["Platform"],
        _angular_common_http__WEBPACK_IMPORTED_MODULE_6__["HttpClient"],
        _api_api_service__WEBPACK_IMPORTED_MODULE_1__["ApiService"]])
], AuthenticationService);



/***/ }),

/***/ "./src/app/shared/utils/camelize.ts":
/*!******************************************!*\
  !*** ./src/app/shared/utils/camelize.ts ***!
  \******************************************/
/*! exports provided: camelizeKeys, snakecaseKeys */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelizeKeys", function() { return camelizeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "snakecaseKeys", function() { return snakecaseKeys; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);


const camelizeKeys = obj => {
    if (Array.isArray(obj)) {
        return obj.map(v => camelizeKeys(v));
    }
    else if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => (Object.assign({}, result, { [Object(lodash__WEBPACK_IMPORTED_MODULE_1__["camelCase"])(key)]: camelizeKeys(obj[key]) })), {});
    }
    return obj;
};
const snakecaseKeys = obj => {
    if (Array.isArray(obj)) {
        return obj.map(v => snakecaseKeys(v));
    }
    else if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => (Object.assign({}, result, { [Object(lodash__WEBPACK_IMPORTED_MODULE_1__["snakeCase"])(key)]: snakecaseKeys(obj[key]) })), {});
    }
    return obj;
};


/***/ }),

/***/ "./src/app/state/app.state.ts":
/*!************************************!*\
  !*** ./src/app/state/app.state.ts ***!
  \************************************/
/*! exports provided: appReducer, appMetaReducers */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appReducer", function() { return appReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appMetaReducers", function() { return appMetaReducers; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var ngrx_store_freeze__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ngrx-store-freeze */ "./node_modules/ngrx-store-freeze/es6/index.js");
/* harmony import */ var _equipment_class_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./equipment-class.state */ "./src/app/state/equipment-class.state.ts");
/* harmony import */ var _equipment_type_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./equipment-type.state */ "./src/app/state/equipment-type.state.ts");
/* harmony import */ var _equipment_model_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./equipment-model.state */ "./src/app/state/equipment-model.state.ts");
/* harmony import */ var _equipment_machine_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./equipment-machine.state */ "./src/app/state/equipment-machine.state.ts");
/* harmony import */ var _equipment_option_type_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./equipment-option-type.state */ "./src/app/state/equipment-option-type.state.ts");
/* harmony import */ var _equipment_option_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./equipment-option.state */ "./src/app/state/equipment-option.state.ts");
/* harmony import */ var _equipment_equipment_reducer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./equipment/equipment.reducer */ "./src/app/state/equipment/equipment.reducer.ts");
/* harmony import */ var _job_planner_job_planner_reducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./job-planner/job-planner.reducer */ "./src/app/state/job-planner/job-planner.reducer.ts");
/* harmony import */ var _materials_materials_reducer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./materials/materials.reducer */ "./src/app/state/materials/materials.reducer.ts");
/* harmony import */ var _restoration_restoration_reducer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./restoration/restoration.reducer */ "./src/app/state/restoration/restoration.reducer.ts");
/* harmony import */ var _subcontractors_subcontractors_reducer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./subcontractors/subcontractors.reducer */ "./src/app/state/subcontractors/subcontractors.reducer.ts");
/* harmony import */ var _trucking_trucking_reducer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./trucking/trucking.reducer */ "./src/app/state/trucking/trucking.reducer.ts");
/* harmony import */ var _user_me_user_me_reducer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./user-me/user-me.reducer */ "./src/app/state/user-me/user-me.reducer.ts");
/* harmony import */ var _equipment_untracked_class_state__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./equipment-untracked-class.state */ "./src/app/state/equipment-untracked-class.state.ts");
/* harmony import */ var _equipment_untracked_machine_state__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./equipment-untracked-machine.state */ "./src/app/state/equipment-untracked-machine.state.ts");
/* harmony import */ var _user_state__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./user.state */ "./src/app/state/user.state.ts");
/* harmony import */ var _user_role_state__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./user-role.state */ "./src/app/state/user-role.state.ts");
/* harmony import */ var _import_status_state__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./import-status.state */ "./src/app/state/import-status.state.ts");
/* harmony import */ var _material_category_state__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./material-category.state */ "./src/app/state/material-category.state.ts");
/* harmony import */ var _material_vendor_state__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./material-vendor.state */ "./src/app/state/material-vendor.state.ts");
/* harmony import */ var _subcontractor_category_state__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./subcontractor-category.state */ "./src/app/state/subcontractor-category.state.ts");
/* harmony import */ var _subcontractor_vendor_state__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./subcontractor-vendor.state */ "./src/app/state/subcontractor-vendor.state.ts");
/* harmony import */ var _vendor_state__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./vendor.state */ "./src/app/state/vendor.state.ts");
/* harmony import */ var _restoration_category_state__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./restoration-category.state */ "./src/app/state/restoration-category.state.ts");
/* harmony import */ var _restoration_type_state__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./restoration-type.state */ "./src/app/state/restoration-type.state.ts");
/* harmony import */ var _restoration_vendor_state__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./restoration-vendor.state */ "./src/app/state/restoration-vendor.state.ts");
/* harmony import */ var _job_equipment_state__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./job-equipment.state */ "./src/app/state/job-equipment.state.ts");
/* harmony import */ var _job_state__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./job.state */ "./src/app/state/job.state.ts");
/* harmony import */ var _job_plan_equip_req_state__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./job-plan-equip-req.state */ "./src/app/state/job-plan-equip-req.state.ts");
/* harmony import */ var _trucking_requirement_state__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./trucking-requirement.state */ "./src/app/state/trucking-requirement.state.ts");
/* harmony import */ var _trucking_move_state__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./trucking-move.state */ "./src/app/state/trucking-move.state.ts");
/* harmony import */ var _trucking_equip_location_state__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./trucking-equip-location.state */ "./src/app/state/trucking-equip-location.state.ts");
/* harmony import */ var _job_plan_state__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./job-plan.state */ "./src/app/state/job-plan.state.ts");
/* harmony import */ var _job_plan_manager_state__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./job-plan-manager.state */ "./src/app/state/job-plan-manager.state.ts");
/* harmony import */ var _job_plan_managed_state__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./job-plan-managed.state */ "./src/app/state/job-plan-managed.state.ts");
/* harmony import */ var _job_plan_crew_req_state__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./job-plan-crew-req.state */ "./src/app/state/job-plan-crew-req.state.ts");
/* harmony import */ var _job_plan_crew_assignment_state__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./job-plan-crew-assignment.state */ "./src/app/state/job-plan-crew-assignment.state.ts");
/* harmony import */ var _crew_state__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./crew.state */ "./src/app/state/crew.state.ts");
/* harmony import */ var _job_locate_state__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./job-locate.state */ "./src/app/state/job-locate.state.ts");
/* harmony import */ var _job_plan_tentative_state__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./job-plan-tentative.state */ "./src/app/state/job-plan-tentative.state.ts");











































const appReducer = {
    crew: _crew_state__WEBPACK_IMPORTED_MODULE_40__["crewReducer"],
    equipmentClass: _equipment_class_state__WEBPACK_IMPORTED_MODULE_3__["equipClassReducer"],
    equipmentType: _equipment_type_state__WEBPACK_IMPORTED_MODULE_4__["equipTypeReducer"],
    equipmentModel: _equipment_model_state__WEBPACK_IMPORTED_MODULE_5__["equipModelReducer"],
    equipmentMachine: _equipment_machine_state__WEBPACK_IMPORTED_MODULE_6__["equipMachineReducer"],
    equipmentOptionType: _equipment_option_type_state__WEBPACK_IMPORTED_MODULE_7__["equipOptTypeReducer"],
    equipmentOption: _equipment_option_state__WEBPACK_IMPORTED_MODULE_8__["equipOptionReducer"],
    equipmentUntrackedClass: _equipment_untracked_class_state__WEBPACK_IMPORTED_MODULE_16__["equipUntrackedClassReducer"],
    equipmentUntrackedMachine: _equipment_untracked_machine_state__WEBPACK_IMPORTED_MODULE_17__["equipUntrackedMachineReducer"],
    equipment: _equipment_equipment_reducer__WEBPACK_IMPORTED_MODULE_9__["reducer"],
    importStatus: _import_status_state__WEBPACK_IMPORTED_MODULE_20__["importStatusReducer"],
    job: _job_state__WEBPACK_IMPORTED_MODULE_30__["jobReducer"],
    jobEquipment: _job_equipment_state__WEBPACK_IMPORTED_MODULE_29__["jobEquipmentReducer"],
    jobLocate: _job_locate_state__WEBPACK_IMPORTED_MODULE_41__["jobLocateReducer"],
    jobPlanner: _job_planner_job_planner_reducer__WEBPACK_IMPORTED_MODULE_10__["reducer"],
    jobPlan: _job_plan_state__WEBPACK_IMPORTED_MODULE_35__["jobPlanReducer"],
    jobPlanManager: _job_plan_manager_state__WEBPACK_IMPORTED_MODULE_36__["jobPlanManagerReducer"],
    jobPlanManaged: _job_plan_managed_state__WEBPACK_IMPORTED_MODULE_37__["jobPlanManagedReducer"],
    jobPlanCrewRequirement: _job_plan_crew_req_state__WEBPACK_IMPORTED_MODULE_38__["jobPlanCrewReqReducer"],
    jobPlanCrewAssignment: _job_plan_crew_assignment_state__WEBPACK_IMPORTED_MODULE_39__["jobPlanCrewAssignmentReducer"],
    jobPlanEquipReq: _job_plan_equip_req_state__WEBPACK_IMPORTED_MODULE_31__["jobPlanEquipReqReducer"],
    jobPlanTentative: _job_plan_tentative_state__WEBPACK_IMPORTED_MODULE_42__["jobPlanTentativeReducer"],
    materials: _materials_materials_reducer__WEBPACK_IMPORTED_MODULE_11__["reducer"],
    materialCategory: _material_category_state__WEBPACK_IMPORTED_MODULE_21__["materialCategoryReducer"],
    materialVendor: _material_vendor_state__WEBPACK_IMPORTED_MODULE_22__["materialVendorReducer"],
    restoration: _restoration_restoration_reducer__WEBPACK_IMPORTED_MODULE_12__["reducer"],
    restorationCategory: _restoration_category_state__WEBPACK_IMPORTED_MODULE_26__["restorationCategoryReducer"],
    restorationType: _restoration_type_state__WEBPACK_IMPORTED_MODULE_27__["restorationTypeReducer"],
    restorationVendor: _restoration_vendor_state__WEBPACK_IMPORTED_MODULE_28__["restorationVendorReducer"],
    subcontractors: _subcontractors_subcontractors_reducer__WEBPACK_IMPORTED_MODULE_13__["reducer"],
    subcontractorCategory: _subcontractor_category_state__WEBPACK_IMPORTED_MODULE_23__["subcontractorCategoryReducer"],
    subcontractorVendor: _subcontractor_vendor_state__WEBPACK_IMPORTED_MODULE_24__["subcontractorVendorReducer"],
    trucking: _trucking_trucking_reducer__WEBPACK_IMPORTED_MODULE_14__["reducer"],
    truckingEquipLocation: _trucking_equip_location_state__WEBPACK_IMPORTED_MODULE_34__["truckingEquipLocationReducer"],
    truckingMove: _trucking_move_state__WEBPACK_IMPORTED_MODULE_33__["truckingMoveReducer"],
    truckingRequirement: _trucking_requirement_state__WEBPACK_IMPORTED_MODULE_32__["truckingRequirementReducer"],
    user: _user_state__WEBPACK_IMPORTED_MODULE_18__["userReducer"],
    userMe: _user_me_user_me_reducer__WEBPACK_IMPORTED_MODULE_15__["reducer"],
    userRole: _user_role_state__WEBPACK_IMPORTED_MODULE_19__["userRoleReducer"],
    vendor: _vendor_state__WEBPACK_IMPORTED_MODULE_25__["vendorReducer"],
};
const appMetaReducers = !src_environments_environment__WEBPACK_IMPORTED_MODULE_1__["environment"].production ? [ngrx_store_freeze__WEBPACK_IMPORTED_MODULE_2__["storeFreeze"]] : [];


/***/ }),

/***/ "./src/app/state/crew.state.ts":
/*!*************************************!*\
  !*** ./src/app/state/crew.state.ts ***!
  \*************************************/
/*! exports provided: crewInitialState, crewSelectors, CrewFacadeBase, crewReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "crewInitialState", function() { return crewInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "crewSelectors", function() { return crewSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CrewFacadeBase", function() { return CrewFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "crewReducer", function() { return crewReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: crewInitialState, selectors: crewSelectors, facade: CrewFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["Crew"]);
function crewReducer(state = crewInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-class.state.ts":
/*!************************************************!*\
  !*** ./src/app/state/equipment-class.state.ts ***!
  \************************************************/
/*! exports provided: equipClassInitialState, equipClassSelectors, EquipClassFacadeBase, equipClassReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipClassInitialState", function() { return equipClassInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipClassSelectors", function() { return equipClassSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipClassFacadeBase", function() { return EquipClassFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipClassReducer", function() { return equipClassReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipClassInitialState, selectors: equipClassSelectors, facade: EquipClassFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentClass"]);
function equipClassReducer(state = equipClassInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-machine.state.ts":
/*!**************************************************!*\
  !*** ./src/app/state/equipment-machine.state.ts ***!
  \**************************************************/
/*! exports provided: equipMachineInitialState, equipMachineSelectors, EquipMachineFacadeBase, equipMachineReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipMachineInitialState", function() { return equipMachineInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipMachineSelectors", function() { return equipMachineSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipMachineFacadeBase", function() { return EquipMachineFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipMachineReducer", function() { return equipMachineReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipMachineInitialState, selectors: equipMachineSelectors, facade: EquipMachineFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentMachine"]);
function equipMachineReducer(state = equipMachineInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-model.state.ts":
/*!************************************************!*\
  !*** ./src/app/state/equipment-model.state.ts ***!
  \************************************************/
/*! exports provided: equipModelInitialState, equipModelSelectors, EquipModelFacadeBase, equipModelReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipModelInitialState", function() { return equipModelInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipModelSelectors", function() { return equipModelSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipModelFacadeBase", function() { return EquipModelFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipModelReducer", function() { return equipModelReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipModelInitialState, selectors: equipModelSelectors, facade: EquipModelFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentModel"]);
function equipModelReducer(state = equipModelInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-option-type.state.ts":
/*!******************************************************!*\
  !*** ./src/app/state/equipment-option-type.state.ts ***!
  \******************************************************/
/*! exports provided: equipOptTypeInitialState, equipOptTypeSelectors, EquipOptTypeFacadeBase, equipOptTypeReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipOptTypeInitialState", function() { return equipOptTypeInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipOptTypeSelectors", function() { return equipOptTypeSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipOptTypeFacadeBase", function() { return EquipOptTypeFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipOptTypeReducer", function() { return equipOptTypeReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipOptTypeInitialState, selectors: equipOptTypeSelectors, facade: EquipOptTypeFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentOptionType"]);
function equipOptTypeReducer(state = equipOptTypeInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-option.state.ts":
/*!*************************************************!*\
  !*** ./src/app/state/equipment-option.state.ts ***!
  \*************************************************/
/*! exports provided: equipOptionInitialState, equipOptionSelectors, EquipOptionFacadeBase, equipOptionReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipOptionInitialState", function() { return equipOptionInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipOptionSelectors", function() { return equipOptionSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipOptionFacadeBase", function() { return EquipOptionFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipOptionReducer", function() { return equipOptionReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipOptionInitialState, selectors: equipOptionSelectors, facade: EquipOptionFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentOption"]);
function equipOptionReducer(state = equipOptionInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-type.state.ts":
/*!***********************************************!*\
  !*** ./src/app/state/equipment-type.state.ts ***!
  \***********************************************/
/*! exports provided: equipTypeInitialState, equipTypeSelectors, EquipTypeFacadeBase, equipTypeReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipTypeInitialState", function() { return equipTypeInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipTypeSelectors", function() { return equipTypeSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipTypeFacadeBase", function() { return EquipTypeFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipTypeReducer", function() { return equipTypeReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipTypeInitialState, selectors: equipTypeSelectors, facade: EquipTypeFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentType"]);
function equipTypeReducer(state = equipTypeInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-untracked-class.state.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/equipment-untracked-class.state.ts ***!
  \**********************************************************/
/*! exports provided: equipUntrackedClassInitialState, equipUntrackedClassSelectors, EquipUntrackedClassFacadeBase, equipUntrackedClassReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipUntrackedClassInitialState", function() { return equipUntrackedClassInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipUntrackedClassSelectors", function() { return equipUntrackedClassSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipUntrackedClassFacadeBase", function() { return EquipUntrackedClassFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipUntrackedClassReducer", function() { return equipUntrackedClassReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipUntrackedClassInitialState, selectors: equipUntrackedClassSelectors, facade: EquipUntrackedClassFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentUntrackedClass"]);
function equipUntrackedClassReducer(state = equipUntrackedClassInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment-untracked-machine.state.ts":
/*!************************************************************!*\
  !*** ./src/app/state/equipment-untracked-machine.state.ts ***!
  \************************************************************/
/*! exports provided: equipUntrackedMachineInitialState, equipUntrackedMachineSelectors, EquipUntrackedMachineFacadeBase, equipUntrackedMachineReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipUntrackedMachineInitialState", function() { return equipUntrackedMachineInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipUntrackedMachineSelectors", function() { return equipUntrackedMachineSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipUntrackedMachineFacadeBase", function() { return EquipUntrackedMachineFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equipUntrackedMachineReducer", function() { return equipUntrackedMachineReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: equipUntrackedMachineInitialState, selectors: equipUntrackedMachineSelectors, facade: EquipUntrackedMachineFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["EquipmentUntrackedMachine"]);
function equipUntrackedMachineReducer(state = equipUntrackedMachineInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/equipment/equipment.actions.ts":
/*!******************************************************!*\
  !*** ./src/app/state/equipment/equipment.actions.ts ***!
  \******************************************************/
/*! exports provided: loadAllEquipment, loadAllEquipmentSuccess, loadAllEquipmentError, loadEquipmentLocations, loadEquipmentLocationsSuccess, loadEquipmentLocationsError, setEquipmentTypeFilter */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllEquipment", function() { return loadAllEquipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllEquipmentSuccess", function() { return loadAllEquipmentSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllEquipmentError", function() { return loadAllEquipmentError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadEquipmentLocations", function() { return loadEquipmentLocations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadEquipmentLocationsSuccess", function() { return loadEquipmentLocationsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadEquipmentLocationsError", function() { return loadEquipmentLocationsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEquipmentTypeFilter", function() { return setEquipmentTypeFilter; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadAllEquipment = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment] Load All');
const loadAllEquipmentSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment API] Load All Success');
const loadAllEquipmentError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment API] Load All Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const loadEquipmentLocations = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment] Load Locations');
const loadEquipmentLocationsSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment] Load Locations Success');
const loadEquipmentLocationsError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment API] Load Locations Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const setEquipmentTypeFilter = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Equipment] Set EquipmentType Filter', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/equipment/equipment.effects.ts":
/*!******************************************************!*\
  !*** ./src/app/state/equipment/equipment.effects.ts ***!
  \******************************************************/
/*! exports provided: EquipmentEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EquipmentEffects", function() { return EquipmentEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _equipment_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./equipment.actions */ "./src/app/state/equipment/equipment.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_equip_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/equip.service */ "./src/app/services/api/equip.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");










let EquipmentEffects = class EquipmentEffects {
    constructor(actions$, equipService, store$) {
        this.actions$ = actions$;
        this.equipService = equipService;
        this.store$ = store$;
        this.loadAllEquipment$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_equipment_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllEquipment"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.equipService.loadAll().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(equip => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentClass"], equip.equipmentClasses));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentType"], equip.equipmentTypes));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentModel"], equip.equipmentModels));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentMachine"], equip.equipmentMachines));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentOption"], equip.equipmentOptions));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentOptionType"], equip.equipmentOptionTypes));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentUntrackedClass"], equip.untrackedClasses));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentUntrackedMachine"], equip.untracked));
            return Object(_equipment_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllEquipmentSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_equipment_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllEquipmentError"])({ error }));
        })))));
        this.loadEquipmentLocations$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_equipment_actions__WEBPACK_IMPORTED_MODULE_3__["loadEquipmentLocations"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.equipService.loadLocations().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobEquipment"], res.jobEquipment));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Job"], res.jobs));
            return Object(_equipment_actions__WEBPACK_IMPORTED_MODULE_3__["loadEquipmentLocationsSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_equipment_actions__WEBPACK_IMPORTED_MODULE_3__["loadEquipmentLocationsError"])({ error }));
        })))));
    }
};
EquipmentEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"] },
    { type: _services_api_equip_service__WEBPACK_IMPORTED_MODULE_5__["EquipService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
EquipmentEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_9__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"],
        _services_api_equip_service__WEBPACK_IMPORTED_MODULE_5__["EquipService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], EquipmentEffects);



/***/ }),

/***/ "./src/app/state/equipment/equipment.reducer.ts":
/*!******************************************************!*\
  !*** ./src/app/state/equipment/equipment.reducer.ts ***!
  \******************************************************/
/*! exports provided: initialState, reducer, selectEquipment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectEquipment", function() { return selectEquipment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _equipment_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./equipment.actions */ "./src/app/state/equipment/equipment.actions.ts");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
    typeFilter: {
        equipType: null,
        optionTypes: [],
    },
};
const equipmentReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_equipment_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllEquipment"], _equipment_actions__WEBPACK_IMPORTED_MODULE_2__["loadEquipmentLocations"], state => (Object.assign({}, state, { typeFilter: Object.assign({}, state.typeFilter), loading: true, loaded: false, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_equipment_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllEquipmentSuccess"], _equipment_actions__WEBPACK_IMPORTED_MODULE_2__["loadEquipmentLocationsSuccess"], state => (Object.assign({}, state, { typeFilter: Object.assign({}, state.typeFilter), loading: false, loaded: true, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_equipment_actions__WEBPACK_IMPORTED_MODULE_2__["setEquipmentTypeFilter"], (state, newFilter) => (Object.assign({}, state, { typeFilter: Object.assign({}, newFilter) }))));
function reducer(state, action) {
    return equipmentReducer(state, action);
}
const selectEquipment = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createFeatureSelector"])('equipment');


/***/ }),

/***/ "./src/app/state/import-status.state.ts":
/*!**********************************************!*\
  !*** ./src/app/state/import-status.state.ts ***!
  \**********************************************/
/*! exports provided: importStatusInitialState, importStatusSelectors, ImportStatusFacadeBase, importStatusReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importStatusInitialState", function() { return importStatusInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importStatusSelectors", function() { return importStatusSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImportStatusFacadeBase", function() { return ImportStatusFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importStatusReducer", function() { return importStatusReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: importStatusInitialState, selectors: importStatusSelectors, facade: ImportStatusFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["ImportStatus"]);
function importStatusReducer(state = importStatusInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-equipment.state.ts":
/*!**********************************************!*\
  !*** ./src/app/state/job-equipment.state.ts ***!
  \**********************************************/
/*! exports provided: jobEquipmentInitialState, jobEquipmentSelectors, JobEquipmentFacadeBase, jobEquipmentReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobEquipmentInitialState", function() { return jobEquipmentInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobEquipmentSelectors", function() { return jobEquipmentSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobEquipmentFacadeBase", function() { return JobEquipmentFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobEquipmentReducer", function() { return jobEquipmentReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobEquipmentInitialState, selectors: jobEquipmentSelectors, facade: JobEquipmentFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobEquipment"]);
function jobEquipmentReducer(state = jobEquipmentInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-locate.state.ts":
/*!*******************************************!*\
  !*** ./src/app/state/job-locate.state.ts ***!
  \*******************************************/
/*! exports provided: jobLocateInitialState, jobLocateSelectors, JobLocateFacadeBase, jobLocateReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobLocateInitialState", function() { return jobLocateInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobLocateSelectors", function() { return jobLocateSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobLocateFacadeBase", function() { return JobLocateFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobLocateReducer", function() { return jobLocateReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobLocateInitialState, selectors: jobLocateSelectors, facade: JobLocateFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobLocate"]);
function jobLocateReducer(state = jobLocateInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan-crew-assignment.effects.ts":
/*!***********************************************************!*\
  !*** ./src/app/state/job-plan-crew-assignment.effects.ts ***!
  \***********************************************************/
/*! exports provided: createJobPlanCrewAssignment, createJobPlanCrewAssignments, deleteCrewAssignment, JobPlanCrewAssignmentEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJobPlanCrewAssignment", function() { return createJobPlanCrewAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJobPlanCrewAssignments", function() { return createJobPlanCrewAssignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCrewAssignment", function() { return deleteCrewAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewAssignmentEffects", function() { return JobPlanCrewAssignmentEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _services_api_job_plan_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @services/api/job-plan.service */ "./src/app/services/api/job-plan.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");








const createJobPlanCrewAssignment = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["createAction"])('[Job Plan Crew Assignment] Create Crew Assignment', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["props"])());
const createJobPlanCrewAssignments = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["createAction"])('[Job Plan Crew Assignment] Create Crew Assignments', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["props"])());
const deleteCrewAssignment = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["createAction"])('[Job Plan Crew Assignment], Delete Crew Assignment', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["props"])());
let JobPlanCrewAssignmentEffects = class JobPlanCrewAssignmentEffects {
    constructor(actions$, jobPlanService, store$) {
        this.actions$ = actions$;
        this.jobPlanService = jobPlanService;
        this.store$ = store$;
        this.deleteCrewAssignment$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["ofType"])(deleteCrewAssignment), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["exhaustMap"])(payload => this.jobPlanService.deleteCrewAssignment(payload.crewAssign).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["DeleteSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlanCrewAssignment"], payload.crewAssign));
            if (payload.crewReq) {
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["Update"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlanCrewRequirement"], payload.crewReq));
            }
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlan"], Object.assign({}, response, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.createJobPlanCrewAssign$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["ofType"])(createJobPlanCrewAssignment), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["exhaustMap"])(payload => this.jobPlanService.createCrewAssignment(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["CreateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlanCrewAssignment"], response.crewAssignment));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["Crew"], response.crew));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.createJobPlansCrewAssign$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["ofType"])(createJobPlanCrewAssignments), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["exhaustMap"])(payload => this.jobPlanService.createManyCrewAssignments(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_6__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["CreateManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlanCrewAssignment"], response.crewAssignments));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["Crew"], response.crews));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_5__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
    }
};
JobPlanCrewAssignmentEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["Actions"] },
    { type: _services_api_job_plan_service__WEBPACK_IMPORTED_MODULE_1__["JobPlanService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"] }
];
JobPlanCrewAssignmentEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_4__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_3__["Actions"],
        _services_api_job_plan_service__WEBPACK_IMPORTED_MODULE_1__["JobPlanService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_2__["Store"]])
], JobPlanCrewAssignmentEffects);



/***/ }),

/***/ "./src/app/state/job-plan-crew-assignment.state.ts":
/*!*********************************************************!*\
  !*** ./src/app/state/job-plan-crew-assignment.state.ts ***!
  \*********************************************************/
/*! exports provided: jobPlanCrewAssignmentInitialState, jobPlanCrewAssignmentSelectors, JobPlanCrewAssignmentFacadeBase, jobPlanCrewAssignmentReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanCrewAssignmentInitialState", function() { return jobPlanCrewAssignmentInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanCrewAssignmentSelectors", function() { return jobPlanCrewAssignmentSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewAssignmentFacadeBase", function() { return JobPlanCrewAssignmentFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanCrewAssignmentReducer", function() { return jobPlanCrewAssignmentReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanCrewAssignmentInitialState, selectors: jobPlanCrewAssignmentSelectors, facade: JobPlanCrewAssignmentFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlanCrewAssignment"]);
function jobPlanCrewAssignmentReducer(state = jobPlanCrewAssignmentInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan-crew-req.state.ts":
/*!**************************************************!*\
  !*** ./src/app/state/job-plan-crew-req.state.ts ***!
  \**************************************************/
/*! exports provided: jobPlanCrewReqInitialState, jobPlanCrewReqSelectors, JobPlanCrewReqFacadeBase, jobPlanCrewReqReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanCrewReqInitialState", function() { return jobPlanCrewReqInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanCrewReqSelectors", function() { return jobPlanCrewReqSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanCrewReqFacadeBase", function() { return JobPlanCrewReqFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanCrewReqReducer", function() { return jobPlanCrewReqReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanCrewReqInitialState, selectors: jobPlanCrewReqSelectors, facade: JobPlanCrewReqFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlanCrewRequirement"]);
function jobPlanCrewReqReducer(state = jobPlanCrewReqInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan-equip-req.state.ts":
/*!***************************************************!*\
  !*** ./src/app/state/job-plan-equip-req.state.ts ***!
  \***************************************************/
/*! exports provided: jobPlanEquipReqInitialState, jobPlanEquipReqSelectors, JobPlanEquipReqFacadeBase, jobPlanEquipReqReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanEquipReqInitialState", function() { return jobPlanEquipReqInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanEquipReqSelectors", function() { return jobPlanEquipReqSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanEquipReqFacadeBase", function() { return JobPlanEquipReqFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanEquipReqReducer", function() { return jobPlanEquipReqReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanEquipReqInitialState, selectors: jobPlanEquipReqSelectors, facade: JobPlanEquipReqFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlanEquipReq"]);
function jobPlanEquipReqReducer(state = jobPlanEquipReqInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan-managed.state.ts":
/*!*************************************************!*\
  !*** ./src/app/state/job-plan-managed.state.ts ***!
  \*************************************************/
/*! exports provided: jobPlanManagedInitialState, jobPlanManagedSelectors, JobPlanManagedFacadeBase, jobPlanManagedReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanManagedInitialState", function() { return jobPlanManagedInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanManagedSelectors", function() { return jobPlanManagedSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanManagedFacadeBase", function() { return JobPlanManagedFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanManagedReducer", function() { return jobPlanManagedReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanManagedInitialState, selectors: jobPlanManagedSelectors, facade: JobPlanManagedFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlanManaged"]);
function jobPlanManagedReducer(state = jobPlanManagedInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan-manager.state.ts":
/*!*************************************************!*\
  !*** ./src/app/state/job-plan-manager.state.ts ***!
  \*************************************************/
/*! exports provided: jobPlanManagerInitialState, jobPlanManagerSelectors, JobPlanManagerFacadeBase, jobPlanManagerReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanManagerInitialState", function() { return jobPlanManagerInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanManagerSelectors", function() { return jobPlanManagerSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanManagerFacadeBase", function() { return JobPlanManagerFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanManagerReducer", function() { return jobPlanManagerReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanManagerInitialState, selectors: jobPlanManagerSelectors, facade: JobPlanManagerFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlanManager"]);
function jobPlanManagerReducer(state = jobPlanManagerInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan-tentative.state.ts":
/*!***************************************************!*\
  !*** ./src/app/state/job-plan-tentative.state.ts ***!
  \***************************************************/
/*! exports provided: jobPlanTentativeInitialState, jobPlanTentativeSelectors, JobPlanTentativeFacadeBase, jobPlanTentativeReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanTentativeInitialState", function() { return jobPlanTentativeInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanTentativeSelectors", function() { return jobPlanTentativeSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanTentativeFacadeBase", function() { return JobPlanTentativeFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanTentativeReducer", function() { return jobPlanTentativeReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanTentativeInitialState, selectors: jobPlanTentativeSelectors, facade: JobPlanTentativeFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlanTentative"]);
function jobPlanTentativeReducer(state = jobPlanTentativeInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-plan.effects.ts":
/*!*******************************************!*\
  !*** ./src/app/state/job-plan.effects.ts ***!
  \*******************************************/
/*! exports provided: createJobPlan, updateJobPlan, getJobPlanDetails, getJobPlanDetailsSuccess, createJobPlanCrewReq, updateJobPlanCrewReq, deleteJobPlanCrewReq, createJobPlanEquipReqs, updateJobPlanEquipReq, deleteJobPlanEquipReq, JobPlanEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJobPlan", function() { return createJobPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateJobPlan", function() { return updateJobPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getJobPlanDetails", function() { return getJobPlanDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getJobPlanDetailsSuccess", function() { return getJobPlanDetailsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJobPlanCrewReq", function() { return createJobPlanCrewReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateJobPlanCrewReq", function() { return updateJobPlanCrewReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteJobPlanCrewReq", function() { return deleteJobPlanCrewReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJobPlanEquipReqs", function() { return createJobPlanEquipReqs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateJobPlanEquipReq", function() { return updateJobPlanEquipReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteJobPlanEquipReq", function() { return deleteJobPlanEquipReq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanEffects", function() { return JobPlanEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _services_api_job_plan_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @services/api/job-plan.service */ "./src/app/services/api/job-plan.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! date-fns */ "./node_modules/date-fns/esm/index.js");
/* harmony import */ var _job_plan_crew_assignment_effects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./job-plan-crew-assignment.effects */ "./src/app/state/job-plan-crew-assignment.effects.ts");










const createJobPlan = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Create Job Plan', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const updateJobPlan = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Update Job Plan', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const getJobPlanDetails = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Get Job Plan Details', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const getJobPlanDetailsSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Get Job Plan Details', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const createJobPlanCrewReq = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Create Crew Requirement', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const updateJobPlanCrewReq = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Update Crew Requirement', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const deleteJobPlanCrewReq = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Delete Crew Requirement', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const createJobPlanEquipReqs = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Create Equipment Requirement', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const updateJobPlanEquipReq = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Update Equipment Requirement', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
const deleteJobPlanEquipReq = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["createAction"])('[Job Plan] Delete Equipment Requirement', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_3__["props"])());
let JobPlanEffects = class JobPlanEffects {
    constructor(actions$, jobPlanService, store$) {
        this.actions$ = actions$;
        this.jobPlanService = jobPlanService;
        this.store$ = store$;
        this.createJobPlanCrewReq$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(createJobPlanCrewReq), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.createCrewReq(payload.crewReq).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["CreateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanCrewRequirement"], response.crewReq));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
            const crewReqId = response.crewReq.id;
            const crewAssignments = payload.crewAssignments.map(ca => (Object.assign({}, ca, { jpCrewReq: crewReqId })));
            if (crewAssignments.length > 0) {
                this.store$.dispatch(Object(_job_plan_crew_assignment_effects__WEBPACK_IMPORTED_MODULE_9__["createJobPlanCrewAssignments"])({ payload: crewAssignments }));
            }
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.createJobPlanEquipReqs$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(createJobPlanEquipReqs), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.createManyEquipReqs(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["CreateManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanEquipReq"], response.equipmentRequests));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.updateJobPlanCrewReq$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(updateJobPlanCrewReq), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.updateCrewReq(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanCrewRequirement"], response.crewReq));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.updateJobPlanEquipReq$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(updateJobPlanEquipReq), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.updateEquipReq(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanEquipReq"], response.equipmentRequest));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.deleteJobPlanCrewReq$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(deleteJobPlanCrewReq), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.deleteCrewReq(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["DeleteSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanCrewRequirement"], payload));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.deleteJobPlanEquipReq$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(deleteJobPlanEquipReq), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.deleteEquipReq(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["DeleteSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanEquipReq"], payload));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response.jobPlan, { details: 'loaded' })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.createJobPlan$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(createJobPlan), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.createWithManager(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["CreateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], response.jobPlan));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Job"], response.job));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["CreateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanManaged"], response.jobPlanManaged));
            if ('manager' in response) {
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanManager"], response.manager));
            }
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.updateJobPlan$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(updateJobPlan), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => this.jobPlanService.replace(null, payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, response, { details: payload.details })));
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.getJobPlanDetails$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(getJobPlanDetails), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(action => action.payload), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(payload => {
            const completedDate = payload.completedDate === null
                ? null
                : typeof payload.completedDate === 'string'
                    ? payload.completedDate
                    : Object(date_fns__WEBPACK_IMPORTED_MODULE_8__["format"])(payload.completedDate, 'yyyy-MM-dd');
            console.log(typeof payload);
            const jp = Object.assign({}, payload, { details: 'loading' });
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], jp));
            return this.jobPlanService.getDetails(payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(response => {
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanCrewRequirement"], response.crewRequirements));
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanCrewAssignment"], response.crewAssignments));
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Crew"], response.crews));
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanEquipReq"], response.equipmentRequirements));
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobLocate"], response.locates));
                this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], Object.assign({}, jp, { details: 'loaded' })));
            })
            // catchError(error => {
            //   console.log(error);
            // })
            );
        })), { dispatch: false });
    }
};
JobPlanEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _services_api_job_plan_service__WEBPACK_IMPORTED_MODULE_4__["JobPlanService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"] }
];
JobPlanEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"],
        _services_api_job_plan_service__WEBPACK_IMPORTED_MODULE_4__["JobPlanService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["Store"]])
], JobPlanEffects);



/***/ }),

/***/ "./src/app/state/job-plan.state.ts":
/*!*****************************************!*\
  !*** ./src/app/state/job-plan.state.ts ***!
  \*****************************************/
/*! exports provided: jobPlanInitialState, jobPlanSelectors, JobPlanFacadeBase, jobPlanReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanInitialState", function() { return jobPlanInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanSelectors", function() { return jobPlanSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlanFacadeBase", function() { return JobPlanFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobPlanReducer", function() { return jobPlanReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobPlanInitialState, selectors: jobPlanSelectors, facade: JobPlanFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["JobPlan"]);
function jobPlanReducer(state = jobPlanInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/job-planner/job-planner.actions.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/job-planner/job-planner.actions.ts ***!
  \**********************************************************/
/*! exports provided: loadJobPlanner, loadJobPlannerSuccess, loadJobPlannerError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadJobPlanner", function() { return loadJobPlanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadJobPlannerSuccess", function() { return loadJobPlannerSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadJobPlannerError", function() { return loadJobPlannerError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadJobPlanner = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Job Planner] Load', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const loadJobPlannerSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Job Planner API] Load Success', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const loadJobPlannerError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Job Planner API] Load Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/job-planner/job-planner.effects.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/job-planner/job-planner.effects.ts ***!
  \**********************************************************/
/*! exports provided: JobPlannerEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobPlannerEffects", function() { return JobPlannerEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _job_planner_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./job-planner.actions */ "./src/app/state/job-planner/job-planner.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_job_planner_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/job-planner.service */ "./src/app/services/api/job-planner.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");










let JobPlannerEffects = class JobPlannerEffects {
    constructor(actions$, jobPlannerService, store$) {
        this.actions$ = actions$;
        this.jobPlannerService = jobPlannerService;
        this.store$ = store$;
        this.loadJobPlanner$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_job_planner_actions__WEBPACK_IMPORTED_MODULE_3__["loadJobPlanner"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(action => this.jobPlannerService.load(action.dateRange).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(jobPlanner => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlan"], jobPlanner.jobPlans.map(jp => (Object.assign({}, jp, { details: 'none' })))));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Job"], jobPlanner.jobs));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanManaged"], jobPlanner.jobPlanManaged));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanManager"], jobPlanner.managers));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["JobPlanTentative"], jobPlanner.tentative));
            return Object(_job_planner_actions__WEBPACK_IMPORTED_MODULE_3__["loadJobPlannerSuccess"])({ dateRange: action.dateRange });
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_job_planner_actions__WEBPACK_IMPORTED_MODULE_3__["loadJobPlannerError"])({ error }));
        })))));
    }
};
JobPlannerEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"] },
    { type: _services_api_job_planner_service__WEBPACK_IMPORTED_MODULE_5__["JobPlannerService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
JobPlannerEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_9__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"],
        _services_api_job_planner_service__WEBPACK_IMPORTED_MODULE_5__["JobPlannerService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], JobPlannerEffects);



/***/ }),

/***/ "./src/app/state/job-planner/job-planner.reducer.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/job-planner/job-planner.reducer.ts ***!
  \**********************************************************/
/*! exports provided: initialState, reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _job_planner_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./job-planner.actions */ "./src/app/state/job-planner/job-planner.actions.ts");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
    startDate: null,
    endDate: null,
};
const jobPlannerReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_job_planner_actions__WEBPACK_IMPORTED_MODULE_2__["loadJobPlanner"], state => (Object.assign({}, state, { loading: true, loaded: false, error: null, startDate: null, endDate: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_job_planner_actions__WEBPACK_IMPORTED_MODULE_2__["loadJobPlannerSuccess"], (state, { dateRange }) => (Object.assign({}, state, { loading: false, loaded: true, error: null, startDate: dateRange.minDate, endDate: dateRange.maxDate }))));
function reducer(state, action) {
    return jobPlannerReducer(state, action);
}


/***/ }),

/***/ "./src/app/state/job.state.ts":
/*!************************************!*\
  !*** ./src/app/state/job.state.ts ***!
  \************************************/
/*! exports provided: jobInitialState, jobSelectors, JobFacadeBase, jobReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobInitialState", function() { return jobInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobSelectors", function() { return jobSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JobFacadeBase", function() { return JobFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jobReducer", function() { return jobReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: jobInitialState, selectors: jobSelectors, facade: JobFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["Job"]);
function jobReducer(state = jobInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/material-category.state.ts":
/*!**************************************************!*\
  !*** ./src/app/state/material-category.state.ts ***!
  \**************************************************/
/*! exports provided: materialCategoryInitialState, materialCategorySelectors, MaterialCategoryFacadeBase, materialCategoryReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialCategoryInitialState", function() { return materialCategoryInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialCategorySelectors", function() { return materialCategorySelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialCategoryFacadeBase", function() { return MaterialCategoryFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialCategoryReducer", function() { return materialCategoryReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: materialCategoryInitialState, selectors: materialCategorySelectors, facade: MaterialCategoryFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["MaterialCategory"]);
function materialCategoryReducer(state = materialCategoryInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/material-vendor.state.ts":
/*!************************************************!*\
  !*** ./src/app/state/material-vendor.state.ts ***!
  \************************************************/
/*! exports provided: materialVendorInitialState, materialVendorSelectors, MaterialVendorFacadeBase, materialVendorReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialVendorInitialState", function() { return materialVendorInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialVendorSelectors", function() { return materialVendorSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialVendorFacadeBase", function() { return MaterialVendorFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "materialVendorReducer", function() { return materialVendorReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: materialVendorInitialState, selectors: materialVendorSelectors, facade: MaterialVendorFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["MaterialVendor"]);
function materialVendorReducer(state = materialVendorInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/materials/materials.actions.ts":
/*!******************************************************!*\
  !*** ./src/app/state/materials/materials.actions.ts ***!
  \******************************************************/
/*! exports provided: loadAllMaterials, loadAllMaterialsSuccess, loadAllMaterialsError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllMaterials", function() { return loadAllMaterials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllMaterialsSuccess", function() { return loadAllMaterialsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllMaterialsError", function() { return loadAllMaterialsError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadAllMaterials = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Materials] Load All');
const loadAllMaterialsSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Materials API] Load All Success');
const loadAllMaterialsError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Materials API] Load All Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/materials/materials.effects.ts":
/*!******************************************************!*\
  !*** ./src/app/state/materials/materials.effects.ts ***!
  \******************************************************/
/*! exports provided: MaterialsEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaterialsEffects", function() { return MaterialsEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _materials_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./materials.actions */ "./src/app/state/materials/materials.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_materials_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/materials.service */ "./src/app/services/api/materials.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");










let MaterialsEffects = class MaterialsEffects {
    constructor(actions$, materialsService, store$) {
        this.actions$ = actions$;
        this.materialsService = materialsService;
        this.store$ = store$;
        this.loadAllMaterials$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_materials_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllMaterials"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.materialsService.loadAll().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(materials => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["MaterialCategory"], materials.materialCategories));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["MaterialVendor"], materials.materialVendors));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Vendor"], materials.vendors));
            return Object(_materials_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllMaterialsSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_materials_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllMaterialsError"])({ error }));
        })))));
    }
};
MaterialsEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"] },
    { type: _services_api_materials_service__WEBPACK_IMPORTED_MODULE_5__["MaterialsService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
MaterialsEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_9__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"],
        _services_api_materials_service__WEBPACK_IMPORTED_MODULE_5__["MaterialsService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], MaterialsEffects);



/***/ }),

/***/ "./src/app/state/materials/materials.reducer.ts":
/*!******************************************************!*\
  !*** ./src/app/state/materials/materials.reducer.ts ***!
  \******************************************************/
/*! exports provided: initialState, reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _materials_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./materials.actions */ "./src/app/state/materials/materials.actions.ts");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
};
const materialsReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_materials_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllMaterials"], state => (Object.assign({}, state, { loading: true, loaded: false, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_materials_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllMaterialsSuccess"], state => (Object.assign({}, state, { loading: false, loaded: true, error: null }))));
function reducer(state, action) {
    return materialsReducer(state, action);
}


/***/ }),

/***/ "./src/app/state/restoration-category.state.ts":
/*!*****************************************************!*\
  !*** ./src/app/state/restoration-category.state.ts ***!
  \*****************************************************/
/*! exports provided: restorationCategoryInitialState, restorationCategorySelectors, RestorationCategoryFacadeBase, restorationCategoryReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationCategoryInitialState", function() { return restorationCategoryInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationCategorySelectors", function() { return restorationCategorySelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationCategoryFacadeBase", function() { return RestorationCategoryFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationCategoryReducer", function() { return restorationCategoryReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: restorationCategoryInitialState, selectors: restorationCategorySelectors, facade: RestorationCategoryFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["RestorationCategory"]);
function restorationCategoryReducer(state = restorationCategoryInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/restoration-type.state.ts":
/*!*************************************************!*\
  !*** ./src/app/state/restoration-type.state.ts ***!
  \*************************************************/
/*! exports provided: restorationTypeInitialState, restorationTypeSelectors, RestorationTypeFacadeBase, restorationTypeReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationTypeInitialState", function() { return restorationTypeInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationTypeSelectors", function() { return restorationTypeSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationTypeFacadeBase", function() { return RestorationTypeFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationTypeReducer", function() { return restorationTypeReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: restorationTypeInitialState, selectors: restorationTypeSelectors, facade: RestorationTypeFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["RestorationType"]);
function restorationTypeReducer(state = restorationTypeInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/restoration-vendor.state.ts":
/*!***************************************************!*\
  !*** ./src/app/state/restoration-vendor.state.ts ***!
  \***************************************************/
/*! exports provided: restorationVendorInitialState, restorationVendorSelectors, RestorationVendorFacadeBase, restorationVendorReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationVendorInitialState", function() { return restorationVendorInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationVendorSelectors", function() { return restorationVendorSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationVendorFacadeBase", function() { return RestorationVendorFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restorationVendorReducer", function() { return restorationVendorReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: restorationVendorInitialState, selectors: restorationVendorSelectors, facade: RestorationVendorFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["RestorationVendor"]);
function restorationVendorReducer(state = restorationVendorInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/restoration/restoration.actions.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/restoration/restoration.actions.ts ***!
  \**********************************************************/
/*! exports provided: loadAllRestoration, loadAllRestorationSuccess, loadAllRestorationError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllRestoration", function() { return loadAllRestoration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllRestorationSuccess", function() { return loadAllRestorationSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllRestorationError", function() { return loadAllRestorationError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadAllRestoration = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Restoration] Load All');
const loadAllRestorationSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Restoration API] Load All Success');
const loadAllRestorationError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Restoration API] Load All Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/restoration/restoration.effects.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/restoration/restoration.effects.ts ***!
  \**********************************************************/
/*! exports provided: RestorationEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RestorationEffects", function() { return RestorationEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _restoration_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./restoration.actions */ "./src/app/state/restoration/restoration.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_restoration_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/restoration.service */ "./src/app/services/api/restoration.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");










let RestorationEffects = class RestorationEffects {
    constructor(actions$, restorationsService, store$) {
        this.actions$ = actions$;
        this.restorationsService = restorationsService;
        this.store$ = store$;
        this.loadAllRestoration$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_restoration_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllRestoration"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.restorationsService.loadAll().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(restorations => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["RestorationCategory"], restorations.restorationCategories));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["RestorationVendor"], restorations.restorationVendors));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["RestorationType"], restorations.restorationTypes));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Vendor"], restorations.vendors));
            return Object(_restoration_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllRestorationSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_restoration_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllRestorationError"])({ error }));
        })))));
    }
};
RestorationEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"] },
    { type: _services_api_restoration_service__WEBPACK_IMPORTED_MODULE_5__["RestorationService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
RestorationEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_9__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"],
        _services_api_restoration_service__WEBPACK_IMPORTED_MODULE_5__["RestorationService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], RestorationEffects);



/***/ }),

/***/ "./src/app/state/restoration/restoration.reducer.ts":
/*!**********************************************************!*\
  !*** ./src/app/state/restoration/restoration.reducer.ts ***!
  \**********************************************************/
/*! exports provided: initialState, reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _restoration_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./restoration.actions */ "./src/app/state/restoration/restoration.actions.ts");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
};
const restorationReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_restoration_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllRestoration"], state => (Object.assign({}, state, { loading: true, loaded: false, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_restoration_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllRestorationSuccess"], state => (Object.assign({}, state, { loading: false, loaded: true, error: null }))));
function reducer(state, action) {
    return restorationReducer(state, action);
}


/***/ }),

/***/ "./src/app/state/state.module.ts":
/*!***************************************!*\
  !*** ./src/app/state/state.module.ts ***!
  \***************************************/
/*! exports provided: StateModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StateModule", function() { return StateModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _ngrx_store_devtools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ngrx/store-devtools */ "./node_modules/@ngrx/store-devtools/fesm2015/store-devtools.js");
/* harmony import */ var _app_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.state */ "./src/app/state/app.state.ts");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _env_environment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @env/environment */ "./src/environments/environment.ts");
/* harmony import */ var _equipment_equipment_effects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./equipment/equipment.effects */ "./src/app/state/equipment/equipment.effects.ts");
/* harmony import */ var _materials_materials_effects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./materials/materials.effects */ "./src/app/state/materials/materials.effects.ts");
/* harmony import */ var _subcontractors_subcontractors_effects__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./subcontractors/subcontractors.effects */ "./src/app/state/subcontractors/subcontractors.effects.ts");
/* harmony import */ var _restoration_restoration_effects__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./restoration/restoration.effects */ "./src/app/state/restoration/restoration.effects.ts");
/* harmony import */ var _trucking_trucking_effects__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./trucking/trucking.effects */ "./src/app/state/trucking/trucking.effects.ts");
/* harmony import */ var _trucking_move_effects__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./trucking-move.effects */ "./src/app/state/trucking-move.effects.ts");
/* harmony import */ var _user_me_user_me_effects__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./user-me/user-me.effects */ "./src/app/state/user-me/user-me.effects.ts");
/* harmony import */ var _job_planner_job_planner_effects__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./job-planner/job-planner.effects */ "./src/app/state/job-planner/job-planner.effects.ts");
/* harmony import */ var _job_plan_effects__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./job-plan.effects */ "./src/app/state/job-plan.effects.ts");
/* harmony import */ var _job_plan_crew_assignment_effects__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./job-plan-crew-assignment.effects */ "./src/app/state/job-plan-crew-assignment.effects.ts");


















let StateModule = class StateModule {
};
StateModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _ngrx_store__WEBPACK_IMPORTED_MODULE_3__["StoreModule"].forRoot(_app_state__WEBPACK_IMPORTED_MODULE_5__["appReducer"], { metaReducers: _app_state__WEBPACK_IMPORTED_MODULE_5__["appMetaReducers"] }),
            _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["EffectsModule"].forRoot([
                _equipment_equipment_effects__WEBPACK_IMPORTED_MODULE_8__["EquipmentEffects"],
                _materials_materials_effects__WEBPACK_IMPORTED_MODULE_9__["MaterialsEffects"],
                _subcontractors_subcontractors_effects__WEBPACK_IMPORTED_MODULE_10__["SubcontractorsEffects"],
                _restoration_restoration_effects__WEBPACK_IMPORTED_MODULE_11__["RestorationEffects"],
                _job_planner_job_planner_effects__WEBPACK_IMPORTED_MODULE_15__["JobPlannerEffects"],
                _job_plan_effects__WEBPACK_IMPORTED_MODULE_16__["JobPlanEffects"],
                _job_plan_crew_assignment_effects__WEBPACK_IMPORTED_MODULE_17__["JobPlanCrewAssignmentEffects"],
                _trucking_trucking_effects__WEBPACK_IMPORTED_MODULE_12__["TruckingEffects"],
                _trucking_move_effects__WEBPACK_IMPORTED_MODULE_13__["TruckingMoveEffects"],
                _user_me_user_me_effects__WEBPACK_IMPORTED_MODULE_14__["UserMeEffects"],
            ]),
            _ngrx_store_devtools__WEBPACK_IMPORTED_MODULE_4__["StoreDevtoolsModule"].instrument({ logOnly: _env_environment__WEBPACK_IMPORTED_MODULE_7__["environment"].production }),
            _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_6__["NgrxAutoEntityModule"].forRoot(),
        ],
    })
], StateModule);



/***/ }),

/***/ "./src/app/state/subcontractor-category.state.ts":
/*!*******************************************************!*\
  !*** ./src/app/state/subcontractor-category.state.ts ***!
  \*******************************************************/
/*! exports provided: subcontractorCategoryInitialState, subcontractorCategorySelectors, SubcontractorCategoryFacadeBase, subcontractorCategoryReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subcontractorCategoryInitialState", function() { return subcontractorCategoryInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subcontractorCategorySelectors", function() { return subcontractorCategorySelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubcontractorCategoryFacadeBase", function() { return SubcontractorCategoryFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subcontractorCategoryReducer", function() { return subcontractorCategoryReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: subcontractorCategoryInitialState, selectors: subcontractorCategorySelectors, facade: SubcontractorCategoryFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["SubcontractorCategory"]);
function subcontractorCategoryReducer(state = subcontractorCategoryInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/subcontractor-vendor.state.ts":
/*!*****************************************************!*\
  !*** ./src/app/state/subcontractor-vendor.state.ts ***!
  \*****************************************************/
/*! exports provided: subcontractorVendorInitialState, subcontractorVendorSelectors, SubcontractorVendorFacadeBase, subcontractorVendorReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subcontractorVendorInitialState", function() { return subcontractorVendorInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subcontractorVendorSelectors", function() { return subcontractorVendorSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubcontractorVendorFacadeBase", function() { return SubcontractorVendorFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subcontractorVendorReducer", function() { return subcontractorVendorReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: subcontractorVendorInitialState, selectors: subcontractorVendorSelectors, facade: SubcontractorVendorFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["SubcontractorVendor"]);
function subcontractorVendorReducer(state = subcontractorVendorInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/subcontractors/subcontractors.actions.ts":
/*!****************************************************************!*\
  !*** ./src/app/state/subcontractors/subcontractors.actions.ts ***!
  \****************************************************************/
/*! exports provided: loadAllSubcontractors, loadAllSubcontractorsSuccess, loadAllSubcontractorsError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllSubcontractors", function() { return loadAllSubcontractors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllSubcontractorsSuccess", function() { return loadAllSubcontractorsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllSubcontractorsError", function() { return loadAllSubcontractorsError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadAllSubcontractors = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Subcontractors] Load All');
const loadAllSubcontractorsSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Subcontractors API] Load All Success');
const loadAllSubcontractorsError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Subcontractors API] Load All Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/subcontractors/subcontractors.effects.ts":
/*!****************************************************************!*\
  !*** ./src/app/state/subcontractors/subcontractors.effects.ts ***!
  \****************************************************************/
/*! exports provided: SubcontractorsEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubcontractorsEffects", function() { return SubcontractorsEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _subcontractors_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./subcontractors.actions */ "./src/app/state/subcontractors/subcontractors.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_subcontractors_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/subcontractors.service */ "./src/app/services/api/subcontractors.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");










let SubcontractorsEffects = class SubcontractorsEffects {
    constructor(actions$, subcontractorsService, store$) {
        this.actions$ = actions$;
        this.subcontractorsService = subcontractorsService;
        this.store$ = store$;
        this.loadAllSubcontractors$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_subcontractors_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllSubcontractors"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.subcontractorsService.loadAll().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(subcontractors => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["SubcontractorCategory"], subcontractors.subcontractorCategories));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["SubcontractorVendor"], subcontractors.subcontractorVendors));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Vendor"], subcontractors.vendors));
            return Object(_subcontractors_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllSubcontractorsSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_subcontractors_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllSubcontractorsError"])({ error }));
        })))));
    }
};
SubcontractorsEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"] },
    { type: _services_api_subcontractors_service__WEBPACK_IMPORTED_MODULE_5__["SubcontractorsService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
SubcontractorsEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_9__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"],
        _services_api_subcontractors_service__WEBPACK_IMPORTED_MODULE_5__["SubcontractorsService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], SubcontractorsEffects);



/***/ }),

/***/ "./src/app/state/subcontractors/subcontractors.reducer.ts":
/*!****************************************************************!*\
  !*** ./src/app/state/subcontractors/subcontractors.reducer.ts ***!
  \****************************************************************/
/*! exports provided: initialState, reducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _subcontractors_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./subcontractors.actions */ "./src/app/state/subcontractors/subcontractors.actions.ts");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
};
const subcontractorsReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_subcontractors_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllSubcontractors"], state => (Object.assign({}, state, { loading: true, loaded: false, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_subcontractors_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllSubcontractorsSuccess"], state => (Object.assign({}, state, { loading: false, loaded: true, error: null }))));
function reducer(state, action) {
    return subcontractorsReducer(state, action);
}


/***/ }),

/***/ "./src/app/state/trucking-equip-location.state.ts":
/*!********************************************************!*\
  !*** ./src/app/state/trucking-equip-location.state.ts ***!
  \********************************************************/
/*! exports provided: truckingEquipLocationInitialState, truckingEquipLocationSelectors, TruckingEquipLocationFacadeBase, truckingEquipLocationReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingEquipLocationInitialState", function() { return truckingEquipLocationInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingEquipLocationSelectors", function() { return truckingEquipLocationSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingEquipLocationFacadeBase", function() { return TruckingEquipLocationFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingEquipLocationReducer", function() { return truckingEquipLocationReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: truckingEquipLocationInitialState, selectors: truckingEquipLocationSelectors, facade: TruckingEquipLocationFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["TruckingEquipLocation"]);
function truckingEquipLocationReducer(state = truckingEquipLocationInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/trucking-move.effects.ts":
/*!************************************************!*\
  !*** ./src/app/state/trucking-move.effects.ts ***!
  \************************************************/
/*! exports provided: unloadMachines, rerouteMachine, TruckingMoveEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unloadMachines", function() { return unloadMachines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerouteMachine", function() { return rerouteMachine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingMoveEffects", function() { return TruckingMoveEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_trucking_move_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @services/api/trucking-move.service */ "./src/app/services/api/trucking-move.service.ts");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _trucking_trucking_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./trucking/trucking.actions */ "./src/app/state/trucking/trucking.actions.ts");









const unloadMachines = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking Move] Unload Machines', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const rerouteMachine = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking Move] Reroute Machine', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
let TruckingMoveEffects = class TruckingMoveEffects {
    constructor(actions$, truckingMoveService, store$) {
        this.actions$ = actions$;
        this.truckingMoveService = truckingMoveService;
        this.store$ = store$;
        this.changeLocation$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["createEffect"])(() => this.actions$.pipe(Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["ofEntityType"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["TruckingMove"], _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["EntityActionTypes"].CreateSuccess, _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["EntityActionTypes"].DeleteSuccess, _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["EntityActionTypes"].DeleteManySuccess, _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["EntityActionTypes"].UpdateSuccess), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(() => Object(_trucking_trucking_actions__WEBPACK_IMPORTED_MODULE_8__["loadTruckingEquipLocs"])())));
        this.unloadMachines$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["ofType"])(unloadMachines), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(action => this.truckingMoveService.unloadMachines(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(moves => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["DeleteManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_2__["TruckingMove"], moves));
            this.store$.dispatch(Object(_trucking_trucking_actions__WEBPACK_IMPORTED_MODULE_8__["loadAllTrucking"])());
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
        this.rerouteMachine$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["ofType"])(rerouteMachine), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["exhaustMap"])(action => this.truckingMoveService.rerouteMachine(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(move => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_7__["UpdateSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_2__["TruckingMove"], move));
            this.store$.dispatch(Object(_trucking_trucking_actions__WEBPACK_IMPORTED_MODULE_8__["loadAllTrucking"])());
        })
        // catchError(error => {
        //   console.log(error);
        // })
        ))), { dispatch: false });
    }
};
TruckingMoveEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["Actions"] },
    { type: _services_api_trucking_move_service__WEBPACK_IMPORTED_MODULE_6__["TruckingMoveService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_1__["Store"] }
];
TruckingMoveEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_4__["Actions"],
        _services_api_trucking_move_service__WEBPACK_IMPORTED_MODULE_6__["TruckingMoveService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_1__["Store"]])
], TruckingMoveEffects);



/***/ }),

/***/ "./src/app/state/trucking-move.state.ts":
/*!**********************************************!*\
  !*** ./src/app/state/trucking-move.state.ts ***!
  \**********************************************/
/*! exports provided: truckingMoveInitialState, truckingMoveSelectors, TruckingMoveFacadeBase, truckingMoveReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingMoveInitialState", function() { return truckingMoveInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingMoveSelectors", function() { return truckingMoveSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingMoveFacadeBase", function() { return TruckingMoveFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingMoveReducer", function() { return truckingMoveReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: truckingMoveInitialState, selectors: truckingMoveSelectors, facade: TruckingMoveFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["TruckingMove"]);
function truckingMoveReducer(state = truckingMoveInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/trucking-requirement.state.ts":
/*!*****************************************************!*\
  !*** ./src/app/state/trucking-requirement.state.ts ***!
  \*****************************************************/
/*! exports provided: truckingRequirementInitialState, truckingRequirementSelectors, TruckingRequirementFacadeBase, truckingRequirementReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingRequirementInitialState", function() { return truckingRequirementInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingRequirementSelectors", function() { return truckingRequirementSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingRequirementFacadeBase", function() { return TruckingRequirementFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truckingRequirementReducer", function() { return truckingRequirementReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: truckingRequirementInitialState, selectors: truckingRequirementSelectors, facade: TruckingRequirementFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["TruckingRequirement"]);
function truckingRequirementReducer(state = truckingRequirementInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/trucking/trucking.actions.ts":
/*!****************************************************!*\
  !*** ./src/app/state/trucking/trucking.actions.ts ***!
  \****************************************************/
/*! exports provided: loadAllTrucking, loadAllTruckingSuccess, loadAllTruckingError, loadTruckingEquipLocs, loadTruckingEquipLocsSuccess, loadTruckingEquipLocsError, setTruckingEquipTypeFilter, createTruckingTimecard, createTruckingTimecardSuccess, createTruckingTimecardError, updateTruckingTimecard, updateTruckingTimecardSuccess, updateTruckingTimecardError, createTruckingRental, createTruckingRentalSuccess, createTruckingRentalError, planRentalReturn, planRentalReturnSuccess, planRentalReturnError, rentalReturn, rentalReturnSuccess, rentalReturnError */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllTrucking", function() { return loadAllTrucking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllTruckingSuccess", function() { return loadAllTruckingSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAllTruckingError", function() { return loadAllTruckingError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadTruckingEquipLocs", function() { return loadTruckingEquipLocs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadTruckingEquipLocsSuccess", function() { return loadTruckingEquipLocsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadTruckingEquipLocsError", function() { return loadTruckingEquipLocsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTruckingEquipTypeFilter", function() { return setTruckingEquipTypeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTruckingTimecard", function() { return createTruckingTimecard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTruckingTimecardSuccess", function() { return createTruckingTimecardSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTruckingTimecardError", function() { return createTruckingTimecardError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTruckingTimecard", function() { return updateTruckingTimecard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTruckingTimecardSuccess", function() { return updateTruckingTimecardSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTruckingTimecardError", function() { return updateTruckingTimecardError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTruckingRental", function() { return createTruckingRental; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTruckingRentalSuccess", function() { return createTruckingRentalSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTruckingRentalError", function() { return createTruckingRentalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "planRentalReturn", function() { return planRentalReturn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "planRentalReturnSuccess", function() { return planRentalReturnSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "planRentalReturnError", function() { return planRentalReturnError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rentalReturn", function() { return rentalReturn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rentalReturnSuccess", function() { return rentalReturnSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rentalReturnError", function() { return rentalReturnError; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadAllTrucking = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Load All');
const loadAllTruckingSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Load All Success');
const loadAllTruckingError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Load All Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const loadTruckingEquipLocs = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Load Equipment Locations');
const loadTruckingEquipLocsSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Load Equipment Locations Success');
const loadTruckingEquipLocsError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Load Equipment Locations Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const setTruckingEquipTypeFilter = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Set Trucking Equip EquipmentType Filter', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const createTruckingTimecard = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Create Timecard', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const createTruckingTimecardSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Create Timecard Success', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const createTruckingTimecardError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Create Timecard Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const updateTruckingTimecard = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Update Timecard', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const updateTruckingTimecardSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Update Timecard Success', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const updateTruckingTimecardError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Update Timecard Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const createTruckingRental = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Create Rental', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const createTruckingRentalSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Create Rental Success', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const createTruckingRentalError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Create Rental Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const planRentalReturn = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Plan Rental Return', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const planRentalReturnSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Plan Rental Return Success', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const planRentalReturnError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Plan Rental Return Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const rentalReturn = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking] Rental Return', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const rentalReturnSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Rental Return Success');
const rentalReturnError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[Trucking API] Rental Return Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/trucking/trucking.effects.ts":
/*!****************************************************!*\
  !*** ./src/app/state/trucking/trucking.effects.ts ***!
  \****************************************************/
/*! exports provided: TruckingEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruckingEffects", function() { return TruckingEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _trucking_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./trucking.actions */ "./src/app/state/trucking/trucking.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_trucking_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/trucking.service */ "./src/app/services/api/trucking.service.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _user_me_user_me_actions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../user-me/user-me.actions */ "./src/app/state/user-me/user-me.actions.ts");











let TruckingEffects = class TruckingEffects {
    constructor(actions$, truckingService, store$) {
        this.actions$ = actions$;
        this.truckingService = truckingService;
        this.store$ = store$;
        this.loadAllTrucking$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllTrucking"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.truckingService.loadAll().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(trucking => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["Job"], trucking.jobs));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingRequirement"], trucking.truckingRequirements));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingMove"], trucking.truckingMoves));
            return Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllTruckingSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllTruckingError"])({ error }));
        })))));
        this.loadTruckingEquipLocs$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadTruckingEquipLocs"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(() => this.truckingService.loadLocations().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadAllSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingEquipLocation"], res.jobEquipment));
            return Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadTruckingEquipLocsSuccess"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadTruckingEquipLocsError"])({ error }));
        })))));
        this.deleteMove$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["ofEntityType"])(_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingMove"], _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["EntityActionTypes"].DeleteSuccess, _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["EntityActionTypes"].CreateSuccess), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(() => Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllTrucking"])())));
        this.createTimecard$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["createTruckingTimecard"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["mergeMap"])(action => this.truckingService.createTimecard(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => Object(_user_me_user_me_actions__WEBPACK_IMPORTED_MODULE_10__["updateUserMeTimecard"])({ timecard: response })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["createTruckingTimecardError"])({ error })))))));
        this.updateTimecard$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["updateTruckingTimecard"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["mergeMap"])(action => this.truckingService.updateTimecard(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(response => {
            if (response.clockOut) {
                return Object(_user_me_user_me_actions__WEBPACK_IMPORTED_MODULE_10__["updateUserMeTimecard"])({ timecard: null });
            }
            else {
                return Object(_user_me_user_me_actions__WEBPACK_IMPORTED_MODULE_10__["updateUserMeTimecard"])({ timecard: response });
            }
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["createTruckingTimecardError"])({ error })))))));
        this.createTruckingRental$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["createTruckingRental"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(action => this.truckingService.createRental(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingMove"], res.truckingMove));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentMachine"], res.equipment));
            return Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["createTruckingRentalSuccess"])({ payload: res });
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["createTruckingRentalError"])({ error }));
        })))));
        this.planRentalReturn$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["planRentalReturn"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(action => this.truckingService.planRentalReturn(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["LoadSuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingMove"], res));
            this.store$.dispatch(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadTruckingEquipLocs"])());
            return Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllTrucking"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["planRentalReturnError"])({ error }));
        })))));
        this.rentalReturn$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["ofType"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["rentalReturn"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["exhaustMap"])(action => this.truckingService.returnRental(action.payload).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => {
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["DeleteManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["TruckingMove"], res.completedMoves));
            this.store$.dispatch(new _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_2__["DeleteManySuccess"](_app_models__WEBPACK_IMPORTED_MODULE_7__["EquipmentMachine"], res.returnedEquipment));
            this.store$.dispatch(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadTruckingEquipLocs"])());
            return Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["loadAllTrucking"])();
        }), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(error => {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_8__["of"])(Object(_trucking_actions__WEBPACK_IMPORTED_MODULE_3__["planRentalReturnError"])({ error }));
        })))));
    }
};
TruckingEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"] },
    { type: _services_api_trucking_service__WEBPACK_IMPORTED_MODULE_5__["TruckingService"] },
    { type: _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"] }
];
TruckingEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_9__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_1__["Actions"],
        _services_api_trucking_service__WEBPACK_IMPORTED_MODULE_5__["TruckingService"],
        _ngrx_store__WEBPACK_IMPORTED_MODULE_6__["Store"]])
], TruckingEffects);



/***/ }),

/***/ "./src/app/state/trucking/trucking.reducer.ts":
/*!****************************************************!*\
  !*** ./src/app/state/trucking/trucking.reducer.ts ***!
  \****************************************************/
/*! exports provided: initialState, reducer, selectTrucking */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectTrucking", function() { return selectTrucking; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");
/* harmony import */ var _trucking_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./trucking.actions */ "./src/app/state/trucking/trucking.actions.ts");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
    typeFilter: {
        equipType: null,
        optionTypes: [],
    },
};
const truckingReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllTrucking"], state => (Object.assign({}, state, { typeFilter: Object.assign({}, state.typeFilter), loading: true, loaded: false, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_2__["loadAllTruckingSuccess"], state => (Object.assign({}, state, { typeFilter: Object.assign({}, state.typeFilter), loading: false, loaded: true, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["on"])(_trucking_actions__WEBPACK_IMPORTED_MODULE_2__["setTruckingEquipTypeFilter"], (state, newFilter) => (Object.assign({}, state, { typeFilter: Object.assign({}, newFilter) }))));
function reducer(state, action) {
    return truckingReducer(state, action);
}
const selectTrucking = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createFeatureSelector"])('trucking');


/***/ }),

/***/ "./src/app/state/user-me/user-me.actions.ts":
/*!**************************************************!*\
  !*** ./src/app/state/user-me/user-me.actions.ts ***!
  \**************************************************/
/*! exports provided: loadUserMe, loadUserMeSuccess, loadUserMeError, updateUserMeTimecard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUserMe", function() { return loadUserMe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUserMeSuccess", function() { return loadUserMeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUserMeError", function() { return loadUserMeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserMeTimecard", function() { return updateUserMeTimecard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");


const loadUserMe = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[User Me] Load');
const loadUserMeSuccess = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[User Me API] Load Success', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const loadUserMeError = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[User Me API] Load Error', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());
const updateUserMeTimecard = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["createAction"])('[User Me] Update Timecard', Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_1__["props"])());


/***/ }),

/***/ "./src/app/state/user-me/user-me.effects.ts":
/*!**************************************************!*\
  !*** ./src/app/state/user-me/user-me.effects.ts ***!
  \**************************************************/
/*! exports provided: UserMeEffects */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserMeEffects", function() { return UserMeEffects; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/effects */ "./node_modules/@ngrx/effects/fesm2015/effects.js");
/* harmony import */ var _user_me_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./user-me.actions */ "./src/app/state/user-me/user-me.actions.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services_api_user_me_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @services/api/user-me.service */ "./src/app/services/api/user-me.service.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");







let UserMeEffects = class UserMeEffects {
    constructor(actions$, userMeService) {
        this.actions$ = actions$;
        this.userMeService = userMeService;
        this.load$ = Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["createEffect"])(() => this.actions$.pipe(Object(_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["ofType"])(_user_me_actions__WEBPACK_IMPORTED_MODULE_3__["loadUserMe"]), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["mergeMap"])(() => this.userMeService.load().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(res => Object(_user_me_actions__WEBPACK_IMPORTED_MODULE_3__["loadUserMeSuccess"])({ payload: res })), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["catchError"])(err => Object(rxjs__WEBPACK_IMPORTED_MODULE_6__["of"])(Object(_user_me_actions__WEBPACK_IMPORTED_MODULE_3__["loadUserMeError"])(err)))))));
    }
};
UserMeEffects.ctorParameters = () => [
    { type: _ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"] },
    { type: _services_api_user_me_service__WEBPACK_IMPORTED_MODULE_5__["UserMeService"] }
];
UserMeEffects = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ngrx_effects__WEBPACK_IMPORTED_MODULE_2__["Actions"],
        _services_api_user_me_service__WEBPACK_IMPORTED_MODULE_5__["UserMeService"]])
], UserMeEffects);



/***/ }),

/***/ "./src/app/state/user-me/user-me.reducer.ts":
/*!**************************************************!*\
  !*** ./src/app/state/user-me/user-me.reducer.ts ***!
  \**************************************************/
/*! exports provided: initialState, reducer, selectUserMeFeature */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialState", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return reducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectUserMeFeature", function() { return selectUserMeFeature; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _user_me_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./user-me.actions */ "./src/app/state/user-me/user-me.actions.ts");
/* harmony import */ var _ngrx_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ngrx/store */ "./node_modules/@ngrx/store/fesm2015/store.js");



const initialState = {
    loaded: false,
    loading: false,
    error: null,
    user: null,
    activeTimecard: null,
};
const userMeReducer = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["createReducer"])(initialState, Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["on"])(_user_me_actions__WEBPACK_IMPORTED_MODULE_1__["loadUserMe"], state => (Object.assign({}, state, { loading: true, loaded: false, error: null }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["on"])(_user_me_actions__WEBPACK_IMPORTED_MODULE_1__["loadUserMeSuccess"], (state, { payload }) => (Object.assign({}, state, { loading: false, loaded: true, error: null, user: Object.assign({}, payload.user), activeTimecard: Object.assign({}, payload.activeTimecard) }))), Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["on"])(_user_me_actions__WEBPACK_IMPORTED_MODULE_1__["updateUserMeTimecard"], (state, { timecard }) => (Object.assign({}, state, { activeTimecard: timecard === null ? null : Object.assign({}, timecard) }))));
function reducer(state, action) {
    return userMeReducer(state, action);
}
const selectUserMeFeature = Object(_ngrx_store__WEBPACK_IMPORTED_MODULE_2__["createFeatureSelector"])('userMe');


/***/ }),

/***/ "./src/app/state/user-role.state.ts":
/*!******************************************!*\
  !*** ./src/app/state/user-role.state.ts ***!
  \******************************************/
/*! exports provided: userRoleInitialState, userRoleSelectors, UserRoleFacadeBase, userRoleReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userRoleInitialState", function() { return userRoleInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userRoleSelectors", function() { return userRoleSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserRoleFacadeBase", function() { return UserRoleFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userRoleReducer", function() { return userRoleReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: userRoleInitialState, selectors: userRoleSelectors, facade: UserRoleFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["UserRole"]);
function userRoleReducer(state = userRoleInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/user.state.ts":
/*!*************************************!*\
  !*** ./src/app/state/user.state.ts ***!
  \*************************************/
/*! exports provided: userInitialState, userSelectors, UserFacadeBase, userReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userInitialState", function() { return userInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userSelectors", function() { return userSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserFacadeBase", function() { return UserFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userReducer", function() { return userReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: userInitialState, selectors: userSelectors, facade: UserFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["User"]);
function userReducer(state = userInitialState) {
    return state;
}


/***/ }),

/***/ "./src/app/state/vendor.state.ts":
/*!***************************************!*\
  !*** ./src/app/state/vendor.state.ts ***!
  \***************************************/
/*! exports provided: vendorInitialState, vendorSelectors, VendorFacadeBase, vendorReducer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vendorInitialState", function() { return vendorInitialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vendorSelectors", function() { return vendorSelectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VendorFacadeBase", function() { return VendorFacadeBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vendorReducer", function() { return vendorReducer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @briebug/ngrx-auto-entity */ "./node_modules/@briebug/ngrx-auto-entity/fesm2015/briebug-ngrx-auto-entity.js");
/* harmony import */ var _app_models__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @app/models */ "./src/app/models/index.ts");



const { initialState: vendorInitialState, selectors: vendorSelectors, facade: VendorFacadeBase, } = Object(_briebug_ngrx_auto_entity__WEBPACK_IMPORTED_MODULE_1__["buildState"])(_app_models__WEBPACK_IMPORTED_MODULE_2__["Vendor"]);
function vendorReducer(state = vendorInitialState) {
    return state;
}


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    gatewayUrl: 'https://heimdall.dobossy.net',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_5__);






if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])()
    .bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.log(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /workspaces/client/valley-rich-client/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map